import * as i0 from '@angular/core';
import { Injectable, Inject, InjectionToken, NgModule } from '@angular/core';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Validators, FormControl, UntypedFormArray, FormGroup, FormArray, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { fromEvent } from 'rxjs';
import * as jsonPath from 'jsonpath/jsonpath';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import * as i2 from 'angular-oauth2-oidc';
import * as i2$1 from '@angular/router';
import { NavigationStart } from '@angular/router';
import * as i2$2 from 'primeng/api';
import * as i2$3 from 'primeng/dynamicdialog';
import * as _ from 'lodash';
import jsonata from 'jsonata';
import Feature from 'ol/Feature';
import { Polygon, Point, LineString } from 'ol/geom';
import { fromExtent } from 'ol/geom/Polygon';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Style, Stroke, Fill, Icon } from 'ol/style';
import * as i1$1 from '@angular/platform-browser';
import { filter, pairwise } from 'rxjs/operators';

class BsEventsService {
    static { this.BS_MODAL_SHOWN = 'shown.bs.modal'; }
    static { this.BS_MODAL_HIDDEN = 'hidden.bs.modal'; }
    constructor() {
        this.registerEvent(BsEventsService.BS_MODAL_SHOWN);
        this.registerEvent(BsEventsService.BS_MODAL_HIDDEN);
    }
    onModalShown() {
        return fromEvent(document, BsEventsService.BS_MODAL_SHOWN);
    }
    onModalHidden() {
        return fromEvent(document, BsEventsService.BS_MODAL_HIDDEN);
    }
    registerEvent(event) {
        var script = document.createElement('script');
        script.innerHTML = "eventRelay('" + event + "');";
        document.body.appendChild(script);
    }
    static { this.ɵfac = function BsEventsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BsEventsService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BsEventsService, factory: BsEventsService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BsEventsService, [{
        type: Injectable
    }], () => [], null); })();

class CacheService {
    constructor() {
        this.templates = new Map();
        this.dynamicComponents = new Map();
    }
    isDynamicComponentCached(hash) {
        return this.dynamicComponents.has(hash);
    }
    cacheDynamicComponent(hash, component) {
        this.dynamicComponents.set(hash, component);
        //console.log(this.dynamicComponents.get(hash));
    }
    getDynamicComponent(hash) {
        return this.dynamicComponents.get(hash);
    }
    isTemplateCached(hash) {
        //console.log(hash);
        //console.log(this.templates);
        return this.templates.has(hash);
    }
    cacheTemplate(hash, template) {
        this.templates.set(hash, template);
        //console.log(this.templates);
    }
    getTemplate(hash) {
        return this.templates.get(hash);
    }
    static { this.ɵfac = function CacheService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CacheService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CacheService, factory: CacheService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CacheService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ConfigurationService {
    static { this.olTypes = {
        BOX: "Box",
        POLYGON: "Polygon",
        POINT: "Point",
        LINE: "LineString",
        CIRCLE: "Circle"
    }; }
    static { this.featureTypes = [{
            label: "Bounding box",
            value: ConfigurationService.olTypes.BOX
        }, {
            label: "Polygon",
            value: ConfigurationService.olTypes.POLYGON
        }, {
            label: "Point",
            value: ConfigurationService.olTypes.POINT
        }, {
            label: "Line",
            value: ConfigurationService.olTypes.LINE
        }]; }
    constructor(env, http, oauthService, router, route, cacheService, location) {
        this.env = env;
        this.http = http;
        this.oauthService = oauthService;
        this.router = router;
        this.route = route;
        this.cacheService = cacheService;
        this.location = location;
        this.languages = [
            { code: 'en', label: 'English' },
            { code: 'fr', label: 'Français' },
            { code: 'es', label: 'Español' },
            { code: 'zh', label: '中文' },
            { code: 'ru', label: 'РУССКИЙ' },
            { code: 'ar', label: 'العربية' }
        ];
        this.isFullscreen = false;
        this.themes = {
            blue: {
                name: "Blue",
                palette: ['#11476B', '#165986', '#447A9E', '#739BB6', '#A1BCCE', '#D0DDE6']
            } /* ,
            dark: {
              name: "Dark",
              palette: ['#373b3f', '#42484d', '#4e555a', '#5a6268', '#666f76', '#727c83']
            } */
        };
        this.i18n = {
            en: {
                "monacoInfoLabel": "Browse Monaco Editor documentation",
                "common.loading": "Loading...",
                "common.advanced-search.clear-button": "Clear",
                "common.advanced-search.clear-all-button": "Clear all",
                "common.advanced-search.search-button": "Search",
                "common.advanced-search.title": "Advanced Search",
                "common.search-bar.advanced-search-button": "Advanced",
                "common.image.copyright": "Copyright",
                "common.image.copyright-text": "FAO. Editorial use only. Photo credits must be given.",
                "common.image.credits": "Credits",
                "common.tableOfContents": "Table of contents",
                "bbox": "Map filter",
                "filterterms.title": "Refine search",
                "filterterms.showless": "show less",
                "filterterms.showmore": "show more",
                "search.placeholder": "Custom search",
                "search.results-list.total": "Showing {{from}}-{{to}} of {{total}} results",
                "search.results-list-grouping.total": "Showing {{total}} results",
                "search.results.noresults": "There are no results",
                "list.request-access": "You do not have necessary permissions to access this section. Click below to request access.",
                "list.access-requested": "Your request to access for <b>{{name}}</b> is still pending for approval.",
                "image-gallery.download.all-images": "All Images",
                "image-gallery.download.all-pdfs": "All PDFs",
                "image-gallery.download.full-size": "Download full size",
                "image-gallery.download.pdf": "Download PDF",
                "meeting.furtherinfo": "Further information",
                "builder.confirm-dialog-header": "Confirmation",
                "map.layers-list.layer-name": "Layer name",
                "map.layers-list.opacity": "Transparence",
                "map.layers-list.title": "Geographical layers",
                "map.layers-list.visibility": "Visibility",
                "map.legends-list.title": "Map legend",
                "map.projections.title": "Change projection",
                "map.source-info.text": "United Nations Geospatial Information Section http://www.un.org/Depts/Cartographic/english/htmain.htm Imagery for continents and oceans reproduced from GEBCO, www.gebco.net",
                "map.source-info.title": "Source of information",
                "map.disclaimer.text": "The boundaries and names shown and the designations used on this map do not imply the expression of any opinion whatsoever on the part of FAO concerning the legal status of any country, territory, city or area or of its authorities, or concerning the delimitation of its frontiers and boundaries. Dashed lines on maps represent approximate border lines for which there may not yet be full agreement.",
                "map.disclaimer.title": "Disclaimer",
                "map.tips.text": "<ul><li>Click on  to turn layers on and off</li><li>Double-click to zoom in</li><li>Drag to pan</li><li>Hold down the shift key and drag to zoom to a particular region</li></ul>",
                "map.tips.title": "Map tips",
                "global.citation.cited": "Cited",
                "global.citation.division": "Fisheries and Aquaculture",
                "global.citation.online": "online",
                "global.citation.rome": "Rome",
                "global.citation.text": "Cite this content as",
                "global.citation.textby": "Text by",
                "global.citation.updated": "Updated",
                "global.citation.in": "In",
                "global.documents.text": "Documents",
                "_action_delete": "Do you want to delete the current record?",
                "_action_unsaved": "You have unsaved data, kindly save before leaving the form",
                "_action_unsaved_accept": "Save",
                "_action_unsaved_reject": "Cancel",
                "form-errors.required": "Field is required",
                "form-errors.min": "Field requires a minimum length of {{min}}",
                "form-errors.max": "Field requires a maximum length of {{max}}",
                "form-errors.validationRegex": "Field doesn't match the requirements",
                "form-errors.validationFormat": "Field doesn't match the format",
                "header.browse": "Browse",
                "header.login": "Login",
                "header.signup": "Sign-up",
                "header.logout": "Logout",
                "header.search": "Search",
                "advanced-search.chips.tooltip": "Enter one ore more keywords and press <enter> to add each of them",
                "advanced-search.select.tooltip": "Select one or more keywords",
                "hierarchy.total-results": "Total results:"
            },
            fr: {
                "header.browse": "Parcourir",
                "header.login": "Se connecter",
                "header.signup": "Registre",
                "header.logout": "Déconnexion",
                "header.search": "Recherche",
                "map.legends-list.title": "Légende de la carte",
                "map.layers-list.title": "Couches géographiques",
                "global.citation.cited": "Cité",
                "global.citation.division": "Pêche et aquaculture",
                "global.citation.online": "en ligne",
                "global.citation.rome": "Rome",
                "global.citation.text": "Citer ce contenu comme",
                "global.citation.textby": "Texte de",
                "global.citation.updated": "Mis à jour",
                "global.citation.in": "Dans"
            },
            es: {
                "header.browse": "Navegar",
                "header.login": "Acceso",
                "header.signup": "Registro",
                "header.logout": "Cerrar sesión",
                "header.search": "Buscar",
                "map.legends-list.title": "Leyenda del mapa",
                "map.layers-list.title": "Capas geográficas",
                "global.citation.cited": "Citado",
                "global.citation.division": "Pesca y Acuicultura",
                "global.citation.online": "en línea",
                "global.citation.rome": "Roma",
                "global.citation.text": "Citar este contenido como",
                "global.citation.textby": "Texto de",
                "global.citation.updated": "Actualizado",
                "global.citation.in": "En"
            },
            ar: {
                "header.browse": "تصفح",
                "header.login": "تسجيل الدخول",
                "header.signup": "يسجل",
                "header.logout": "تسجيل الخروج",
                "header.search": "يبحث"
            },
            zh: {
                "header.browse": "瀏覽",
                "header.login": "登入",
                "header.signup": "登記",
                "header.logout": "退出",
                "header.search": "搜尋"
            },
            ru: {
                "header.browse": "Просматривать",
                "header.login": "Авторизоваться",
                "header.signup": "Зарегистрироваться",
                "header.logout": "Выйти",
                "header.search": "Поиск"
            }
        };
        this.cardTypes = {
            CARD: 'card',
            CARDHORIZONTAL: 'card-horizontal',
            CARDHORIZONTALCAPTION: 'card-horizontal-caption',
            CARDOVERLAY: 'card-overlay',
            CARDPUBLICATION: 'card-publication',
            CARDPUBLICATIONHORIZONTAL: 'card-publication-horizontal',
            CARDPHOTO: 'card-photo',
            CARDPHOTOHORIZONTAL: 'card-photo-horizontal',
            CARDVIDEO: 'card-video',
            CARDVIDEOHORIZONTAL: 'card-video-horizontal',
            CARDNEWSHORIZONTAL: 'card-news-horizontal',
            CARDMEETING: 'card-meeting',
            CARDFULL: 'card-full',
            HERO: 'hero'
        };
        this.cardTypesList = [
            {
                value: "card",
                label: 'Card'
            },
            {
                value: "card-horizontal",
                label: 'Horizontal'
            },
            {
                value: "card-horizontal-caption",
                label: 'Horizontal with caption'
            },
            {
                value: "card-overlay",
                label: 'Overlay'
            },
            {
                value: "card-news-horizontal",
                label: 'News horizontal'
            },
            {
                value: "card-publication",
                label: 'Publication'
            },
            {
                value: "card-publication-horizontal",
                label: 'Publication horizontal'
            },
            {
                value: "card-photo",
                label: 'Photo'
            },
            {
                value: "card-photo-horizontal",
                label: 'Photo horizontal'
            },
            {
                value: "card-video",
                label: 'Video'
            },
            {
                value: "card-video-horizontal",
                label: 'Video horizontal'
            },
            {
                value: "card-meeting",
                label: 'Meeting'
            },
            {
                value: "card-full",
                label: 'Full width'
            },
            {
                value: "hero",
                label: 'Hero'
            }
        ];
        this.roles = [{
                value: "ADMIN",
                label: 'Admin'
            }, {
                value: "MANAGER",
                label: 'Manager'
            }, {
                value: "VIEWER",
                label: 'Viewer'
            }, {
                value: "EDITOR",
                label: 'Editor'
            }];
        this.parameterTypes = [
            {
                label: "string",
                value: "string"
            }, {
                label: "number",
                value: "number"
            }, {
                label: "boolean",
                value: "boolean"
            }
        ];
        this.fieldTypes = [
            {
                label: "text",
                value: "text"
            }, {
                label: "number",
                value: "number"
            }, {
                label: "array",
                value: "array"
            }
        ];
        this.sorts = [
            {
                label: "ASC",
                value: "ASC"
            }, {
                label: "DESC",
                value: "DESC"
            }
        ];
        this.dataFormats = [
            {
                label: "2018-01-01",
                value: "YYYY-MM-DD"
            }
        ];
        this.resultTypes = [
            {
                label: "normal",
                value: "normal"
            }, {
                label: "aggregation",
                value: "aggregation"
            }
        ];
        this.layoutCategories = [
            {
                label: "Web",
                value: "web"
            }, {
                label: "Mobile",
                value: "mobile"
            }
        ];
        this.layoutTypes = [
            {
                label: "Table",
                value: "table"
            }, {
                label: "Columns",
                value: "columns"
            }, {
                label: "Tabs",
                value: "tabs"
            }
        ];
        this.metadataTypes = [
            {
                label: "lang",
                value: "lang"
            }, {
                label: "alias",
                value: "alias"
            }, {
                label: "default",
                value: "default"
            }
        ];
        this.views = [
            {
                label: "Table",
                value: "table"
            },
            {
                label: "List",
                value: "list"
            },
            {
                label: "Grid",
                value: "grid"
            }
        ];
        this.spaces = [];
        this.references = {};
        if (!this.env.templateSpace) {
            this.env.templateSpace = "faidp";
        }
        if (!this.env.templateCollection) {
            this.env.templateCollection = "systemtemplates";
        }
        if (!this.env.monacoEditorDocumentation) {
            this.env.monacoEditorDocumentation = "https://code.visualstudio.com/docs/editor/codebasics";
        }
        if (!this.env.debug) {
            this.env.debug = false;
        }
        if (!this.env.options) {
            this.env.options = {};
        }
        if (!this.env.options.maxSize) {
            this.env.options.maxSize = 20;
        }
        if (!this.env.i18n) {
            this.env.i18n = this.i18n;
        }
        else {
            //Initialization of the missing labels in case they are not provided through the env
            this.enrichProperties(this.i18n);
        }
        if (this.env.hosted === undefined) {
            this.env.hosted = false;
        }
        if (this.env.themes) {
            for (let theme in this.env.themes) {
                if (!this.themes[theme]) {
                    this.themes[theme] = this.env.themes[theme];
                }
                else {
                    for (let opt in this.env.themes[theme]) {
                        this.themes[theme][opt] = this.env.themes[theme][opt];
                    }
                }
            }
        }
        if (!this.env.theme) {
            this.env.theme = 'blue';
        }
        document.body.setAttribute('data-theme', this.env.theme);
    }
    getCardTypes(allowed) {
        let items = [];
        for (let key in this.cardTypesList) {
            if (allowed?.length > 0) {
                if (allowed.includes(this.cardTypesList[key].value)) {
                    items.push(this.cardTypesList[key]);
                }
            }
            else {
                items.push(this.cardTypesList[key]);
            }
        }
        return items;
    }
    getLanguages(all = false) {
        if (all) {
            return [{ code: 'all', label: 'all' }].concat(this.languages);
        }
        else {
            return this.languages;
        }
    }
    getLanguageByCode(code, prop) {
        let items = this.languages.filter(item => item.code === code);
        if (items.length > 0) {
            return items[0][prop ? prop : 'label'];
        }
        else {
            return '';
        }
    }
    cleanAliasFromLanguage(alias) {
        if (alias.includes('/')) {
            let last = alias.substring(alias.lastIndexOf('/') + 1);
            if (this.languages.findIndex(item => item.code === last) >= 0) {
                return alias.substring(0, alias.lastIndexOf('/'));
            }
            else {
                return alias;
            }
        }
        else {
            return alias;
        }
    }
    enrichProperties(props) {
        for (let lang in props) {
            if (!this.env.i18n[lang]) {
                this.env.i18n[lang] = this.i18n[lang];
            }
            else {
                this.env.i18n[lang] = Object.assign({}, props[lang], this.env.i18n[lang]);
            }
        }
    }
    enrichLanguageProperties(lang, props) {
        let items = {};
        for (let i = 0; i < props.length; i++) {
            items[props[i].id] = props[i].label;
        }
        this.env.i18n[lang] = Object.assign({}, this.env.i18n[lang], items);
    }
    getUser() {
        this.user = this.oauthService.getIdentityClaims();
        return this.user;
    }
    async getConfigurations() {
        if (!this.cacheService.configurations) {
            if (this.env.configurationsFile) {
                this.cacheService.configurations = await this.loadFile(this.env.configurationsFile);
            }
            else {
                this.cacheService.configurations = [];
            }
            for (let i = 0; i < this.cacheService.configurations.length; i++) {
                this.cacheService.configurations[i].paths = this.cacheService.configurations[i].paths?.sort((a, b) => b.localeCompare(a));
            }
        }
    }
    findRoute(url) {
        //url = url.substring(1).substring(url.substring(1).indexOf('/'));
        url = url.split("?")[0];
        if (!url.endsWith("/")) {
            url = url + "/";
        }
        for (let i = 0; i < this.cacheService.configurations.length; i++) {
            let matches = this.cacheService.configurations[i].paths?.find(item => {
                let exactMatch = new RegExp(item, "gi");
                let m = url.matchAll(exactMatch);
                let isMatching = false;
                for (const match of m) {
                    this.cacheService.configurations[i].alias = match[1] > "" ? (match[1].endsWith("/") ? match[1].substring(0, match[1].length - 1) : match[1]) : null;
                    if (this.getLanguageByCode(this.cacheService.configurations[i].alias.substring(this.cacheService.configurations[i].alias.lastIndexOf('/') + 1)) > '') {
                        this.cacheService.configurations[i].alias = this.cacheService.configurations[i].alias.substring(0, this.cacheService.configurations[i].alias.lastIndexOf('/'));
                    }
                    isMatching = true;
                }
                if (isMatching) {
                    return m;
                }
                else {
                    return null;
                }
            });
            if (matches) {
                return {
                    space: this.cacheService.configurations[i].space || this.env.space,
                    collection: this.cacheService.configurations[i].collection,
                    url: url,
                    alias: this.cacheService.configurations[i].alias,
                    restricted: this.cacheService.configurations[i].restricted || false,
                    editing: this.cacheService.configurations[i].editing
                };
            }
        }
        return null;
    }
    getThemesList() {
        let themes = [];
        for (let key in this.themes) {
            themes.push({
                value: key,
                label: this.themes[key].name || key
            });
        }
        return themes;
    }
    changeTheme() {
        document.body.setAttribute('data-theme', this.env.theme);
        this.router.navigate([this.router.url], {
            onSameUrlNavigation: 'reload'
        });
    }
    getTranslation(key, params) {
        if (!params) {
            return this.env.i18n[this.env.currentLang || this.env.defaultLang][key];
        }
        else {
            let label = this.env.i18n[this.env.currentLang || this.env.defaultLang][key];
            if (label > "") {
                for (let key in params) {
                    label = label.replace("{{" + key + "}}", params[key]);
                }
            }
            return label;
        }
    }
    isLoggedIn() {
        if (this.oauthService.getIdentityClaims()) {
            this.user = this.oauthService.getIdentityClaims();
            return true;
        }
        else {
            return false;
        }
    }
    login() {
        window.sessionStorage.clear();
        window.localStorage.clear();
        this.env.sessionExpNotification = false;
        this.oauthService.setupAutomaticSilentRefresh();
        this.oauthService.redirectUri = this.env.redirectUrl;
        this.oauthService.loadDiscoveryDocumentAndLogin();
    }
    logout(redirectUrl, redirect = true) {
        this.oauthService.revokeTokenAndLogout().then(res => {
            window.sessionStorage.clear();
            window.localStorage.clear();
            this.profile = null;
            this.user = null;
            if (redirect) {
                if (redirectUrl > "") {
                    window.location.href = this.env.siteUrl + redirectUrl;
                }
                else {
                    this.router.navigate(['/login/' + this.env.currentLang], {
                        queryParams: {
                            redirectUrl: window.location.href
                        },
                        skipLocationChange: false
                    });
                }
            }
        });
    }
    getUserProfile(space, res) {
        this.spaces = [];
        let params = [];
        for (let y = 0; y < res.spaceCollectionFilters?.length; y++) {
            let filter = space + '_' + res.spaceCollectionFilters[y].name + '_';
            for (let j = 0; j < res.spaceCollectionFilters[y].filters?.length; j++) {
                params.push({
                    name: filter + res.spaceCollectionFilters[y].filters[j].field.replace(new RegExp(this.escapeRegExp('.'), 'g'), '_'),
                    value: res.spaceCollectionFilters[y].filters[j].values?.toString(),
                    type: 'string',
                    workspace: space,
                    collection: res.spaceCollectionFilters[y].name,
                    field: res.spaceCollectionFilters[y].filters[j].field
                });
            }
        }
        this.globalUserParams = params;
        this.globalUserSpaceCollectionActions = res.spaceCollectionActions;
        this.globalUserSpaceRole = res.spaceRole;
        console.log(this.globalUserParams);
    }
    enrichGlobalParams(space, roleType, dynamicForm, view) {
        if (!this.globalUserParams) {
            return dynamicForm;
        }
        if (!dynamicForm.acceptedParams) {
            dynamicForm.acceptedParams = [];
        }
        if (!dynamicForm.params) {
            dynamicForm.params = [];
        }
        if (dynamicForm.params.findIndex(item => item.name === 'global_view') <= 0) {
            dynamicForm.params.push({
                name: 'global_view',
                value: view
            });
            dynamicForm.acceptedParams.push({
                name: 'global_view',
                type: 'string'
            });
        }
        if (this.oauthService.getIdentityClaims()) {
            if (dynamicForm.params.findIndex(item => item.name === 'global_userId') <= 0) {
                dynamicForm.params.push({
                    name: 'global_userId',
                    value: this.oauthService.getIdentityClaims().id
                });
                dynamicForm.acceptedParams.push({
                    name: 'global_userId',
                    type: 'string'
                });
            }
            if (dynamicForm.params.findIndex(item => item.name === 'global_userName') <= 0) {
                dynamicForm.params.push({
                    name: 'global_userName',
                    value: this.oauthService.getIdentityClaims().email
                });
                dynamicForm.acceptedParams.push({
                    name: 'global_userName',
                    type: 'string'
                });
            }
            for (let i = 0; i < this.globalUserParams.length; i++) {
                if (this.globalUserParams[i].workspace === space && this.globalUserParams[i].collection === (dynamicForm.collection || dynamicForm.id)) {
                    if (dynamicForm.params.findIndex(item => item.name === 'global_userRole_' + this.globalUserParams[i].name) <= 0) {
                        dynamicForm.params.push({
                            name: 'global_userRole_' + this.globalUserParams[i].name,
                            value: this.globalUserParams[i].value
                        });
                        dynamicForm.acceptedParams.push({
                            name: 'global_userRole_' + this.globalUserParams[i].name,
                            type: this.globalUserParams[i].type
                        });
                    }
                }
            }
            if (roleType === 'ADMIN') {
                if (dynamicForm.params.findIndex(item => item.name === 'global_admin') <= 0) {
                    dynamicForm.params.push({
                        name: 'global_admin',
                        value: true
                    });
                    dynamicForm.acceptedParams.push({
                        name: 'global_admin',
                        type: 'boolean'
                    });
                }
            }
            else if (roleType === 'MANAGER') {
                if (dynamicForm.params.findIndex(item => item.name === 'global_manager') <= 0) {
                    dynamicForm.params.push({
                        name: 'global_manager',
                        value: true
                    });
                    dynamicForm.acceptedParams.push({
                        name: 'global_manager',
                        type: 'boolean'
                    });
                }
            }
            else if (roleType === 'EDITOR') {
                if (dynamicForm.params.findIndex(item => item.name === 'global_editor') <= 0) {
                    dynamicForm.params.push({
                        name: 'global_editor',
                        value: true
                    });
                    dynamicForm.acceptedParams.push({
                        name: 'global_editor',
                        type: 'boolean'
                    });
                }
            }
            else if (roleType === 'VIEWER') {
                if (dynamicForm.params.findIndex(item => item.name === 'global_viewer') <= 0) {
                    dynamicForm.params.push({
                        name: 'global_viewer',
                        value: true
                    });
                    dynamicForm.acceptedParams.push({
                        name: 'global_viewer',
                        type: 'boolean'
                    });
                }
            }
        }
        console.log(dynamicForm.params);
        return dynamicForm;
    }
    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
    getProfileDetail(workspace) {
        if (!this.profile) {
            return null;
        }
        return this.profile[workspace];
    }
    async load() {
        this.env.defaultControls = this.getDefaultControls();
        this.env.defaultForm = this.getDefaultForm();
        this.env.defaultControlIcons = this.getDefaultControlIcons();
        this.env.defaultControlProperties = this.getDefaultControlProperties();
        this.env.languages = this.getLanguages();
        this.env.jsonata = this.getJsonataFunctions();
        let config = this.getConfig();
        this.env.advancedSearch = config.advancedSearch;
        this.env.sort = config.sort;
        this.env.grouping = config.grouping;
    }
    loadFile(path, responseType) {
        if (!responseType) {
            responseType = 'json';
        }
        return this.http.get(path, { responseType: responseType }).toPromise();
    }
    getConfig() {
        return {
            "advancedSearch": {
                "multiple": {
                    "separator": ",",
                    "regexp": ",(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)",
                    "condition": " OR "
                },
                "regexp": ";(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)",
                "separator": "=",
                "suffix": ";",
                "paramValueSeparator": ":",
                "termConcatenator": "|"
            },
            "sort": {
                "separator": ",",
                "paramValueSeparator": ":"
            },
            "grouping": {
                "separator": ","
            }
        };
    }
    getJsonataFunctions() {
        return "$isEmail:=function($email){($emailMatcher :=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;$count($emailMatcher($email).groups)>0;)}; $isInRange:=function($value, $minVal, $maxVal){($value >= $minVal and $value <= $maxVal;)};";
    }
    getDefaultControlProperties() {
        return [
            { "value": "label", "label": "Label", "type": "text", "required": true, "showInList": true, "showValue": true },
            { "value": "shortlabel", "label": "Short label", "type": "text", "required": true, "showInList": true, "showValue": true },
            { "value": "tooltip", "label": "Tooltip", "type": "text", "showInList": true, "showValue": false },
            { "value": "placeholder", "label": "Placeholder", "type": "text", "showInList": true, "showValue": false },
            { "value": "help", "label": "Help", "type": "html", "showInList": true, "showValue": false },
            { "value": "quickhelp", "label": "Quick help", "type": "html", "showInList": true, "showValue": false }
        ];
    }
    getDefaultControlIcons() {
        return {
            "separator": "fas fa-window-minimize",
            "text": "fas fa-terminal",
            "textarea": "fas fa-font",
            "number": "fas fa-hashtag",
            "checkbox": "fas fa-check-square",
            "checkboxlist": "fas fa-list",
            "select": "fas fa-th-list",
            "keyselect": "fa-solid fa-key",
            "groupselect": "fas fa-list-alt",
            "multiselect": "fas fa-bars",
            "truefalse": "fa-solid fa-power-off",
            "radiolist": "fas fa-list-ul",
            "title": "bi bi-fonts",
            "subtitle": "bi bi-fonts",
            "label": "bi bi-type-bold",
            "latlong": "bi bi-geo-alt-fill",
            "datetime": "fa fa-calendar",
            "image": "bi bi-card-image",
            "video": "bi bi-camera-reels-fill",
            "hidden": "bi bi-eye-slash-fill",
            "group": "fa fa-th-large",
            "array": "bi bi-columns",
            "form": "bi bi-file-earmark-text",
            "scoring": "bi bi-code",
            "sequence": "bi bi-123",
            "json": "bi bi-filetype-json",
            "fileupload": "bi bi-cloud-upload",
            "code": "bi bi-code-slash",
            "geogeometry": "fa-solid fa-draw-polygon",
            "geoline": "fa-solid fa-draw-polygon",
            "geopoint": "fa-solid fa-location-dot",
            "geopolygon": "fa-solid fa-draw-polygon"
        };
    }
    getDefaultForm() {
        return {
            "newForm": {
                "name": "New Form",
                "visibility": "protected",
                "reader": [],
                "ownerData": [],
                "readerData": [],
                "validityStartDate": null,
                "validityEndDate": null,
                "forms": [],
                "components": [],
                "options": [],
                "properties": [],
                "acceptedParams": [],
                "dynamicFields": [],
                "viewConfig": {
                    "resultsPage": {
                        "itemsPerPage": 30,
                        "languageParams": {},
                        "fields": [],
                        "grouping": {
                            "groupedDisplay": false,
                            "listResult": [
                                {
                                    "type": "normal"
                                },
                                {
                                    "type": "aggregation"
                                }
                            ],
                            "aggFields": [],
                            "aggSetSize": 1,
                            "aggSize": 2000
                        }
                    }
                }
            }
        };
    }
    getDefaultControls(flat = false) {
        let controls = [
            {
                "header": "Basic",
                "showOnLoad": "true",
                "items": [
                    {
                        "pos": 1,
                        "type": "text",
                        "name": "Text Field",
                        "enabled": true,
                        "visible": true,
                        "value": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "textarea",
                        "enabled": true,
                        "visible": true,
                        "name": "Text Area",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "dynamichtml",
                        "enabled": true,
                        "visible": true,
                        "name": "Text Area",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "number",
                        "enabled": true,
                        "visible": true,
                        "step": "0.01",
                        "name": "Number",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "truefalse",
                        "enabled": true,
                        "visible": true,
                        "name": "True/False",
                        "value": "true",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "checkbox",
                        "enabled": true,
                        "visible": true,
                        "name": "Checkbox",
                        "value": "true",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "checkboxlist",
                        "enabled": true,
                        "visible": true,
                        "name": "Checkbox List",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "select",
                        "name": "Select",
                        "enabled": true,
                        "visible": true,
                        "datasource": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "multiselect",
                        "name": "Multiselect",
                        "enabled": true,
                        "visible": true,
                        "datasource": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "groupselect",
                        "name": "Group select",
                        "enabled": true,
                        "visible": true,
                        "datasource": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "radiolist",
                        "enabled": true,
                        "visible": true,
                        "name": "Radio List",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "title",
                        "name": "Title",
                        "enabled": true,
                        "visible": true,
                        "value": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "subtitle",
                        "name": "Subtitle/Section",
                        "enabled": true,
                        "visible": true,
                        "value": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "label",
                        "name": "Label",
                        "enabled": true,
                        "visible": true,
                        "value": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "separator",
                        "name": "Separator",
                        "enabled": true,
                        "visible": true,
                        "value": "",
                        "validation": {}
                    }
                ]
            },
            {
                "header": "Advanced",
                "showOnLoad": "false",
                "items": [
                    {
                        "pos": 1,
                        "type": "datetime",
                        "enabled": true,
                        "visible": true,
                        "name": "Date",
                        "displayFormat": "YYYY-MM-DD",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "image",
                        "enabled": true,
                        "visible": true,
                        "name": "Image",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "video",
                        "enabled": true,
                        "visible": true,
                        "name": "Video",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "name": "Field set",
                        "enabled": true,
                        "visible": true,
                        "type": "group",
                        "components": [],
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "name": "Array",
                        "enabled": true,
                        "visible": true,
                        "type": "array",
                        "components": [],
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "keyselect",
                        "name": "Key Select",
                        "enabled": true,
                        "visible": true,
                        "datasource": "",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "form",
                        "enabled": true,
                        "visible": true,
                        "name": "Nested Form",
                        "validation": {},
                        "params": [],
                        "refFormType": "internal"
                    },
                    {
                        "pos": 1,
                        "type": "code",
                        "enabled": true,
                        "visible": true,
                        "name": "Code",
                        "validation": {},
                        "mode": "html"
                    },
                    {
                        "pos": 1,
                        "type": "fileupload",
                        "enabled": true,
                        "visible": true,
                        "name": "Files",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "geogeometry",
                        "enabled": true,
                        "visible": true,
                        "name": "Geometry",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "geoline",
                        "enabled": true,
                        "visible": true,
                        "name": "Line",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "geopoint",
                        "enabled": true,
                        "visible": true,
                        "name": "Point",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "geopolygon",
                        "enabled": true,
                        "visible": true,
                        "name": "Polygon",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "json",
                        "enabled": true,
                        "visible": true,
                        "name": "Json",
                        "validation": {}
                    },
                    {
                        "pos": 1,
                        "type": "sequence",
                        "enabled": true,
                        "visible": false,
                        "name": "Sequence",
                        "step": "1"
                    },
                    {
                        "pos": 1,
                        "type": "scoring",
                        "enabled": true,
                        "visible": true,
                        "name": "Scoring",
                        "validation": {}
                    }
                ]
            },
            {
                "header": "Custom components",
                "showOnLoad": "false",
                "items": [
                    {
                        "pos": 1,
                        "name": "Position",
                        "enabled": true,
                        "visible": true,
                        "type": "latlong",
                        "components": [
                            {
                                "pos": 1,
                                "code": "useCurrentLocation",
                                "type": "checkbox",
                                "value": "true",
                                "validation": {}
                            },
                            {
                                "pos": 3,
                                "code": "longitude",
                                "step": 0.01,
                                "type": "number",
                                "value": "",
                                "validation": {}
                            },
                            {
                                "pos": 4,
                                "code": "latitude",
                                "step": 0.01,
                                "type": "number",
                                "value": "",
                                "validation": {}
                            }
                        ],
                        "validation": {}
                    }
                ]
            }
        ];
        if (!flat) {
            return controls;
        }
        else {
            let flattened = [];
            for (let i = 0; i < controls.length; i++) {
                flattened = flattened.concat(controls[i].items);
            }
            return flattened;
        }
    }
    getFormControlIcon(type) {
        return this.env.defaultControlIcons[type] || 'bi bi-list';
    }
    getAlias(item, config) {
        let metadata = {};
        let metadatas = jsonPath.query(item, '$.metadata');
        if (metadatas.length > 0) {
            metadata = metadatas[0];
        }
        if (config.defaultAlias) {
            if (typeof (metadata.alias) === 'object') {
                return metadata.defaultAlias || metadata.alias[0];
            }
            else {
                return metadata.defaultAlias || metadata.alias;
            }
        }
        else {
            let alias = '';
            if (config.alias) {
                for (let i = 0; i < config.alias.values.length; i++) {
                    let attrValues = jsonPath.query(item, '$.' + config.alias.values[i]);
                    if (attrValues.length > 0) {
                        if (alias > '') {
                            alias = alias + (config.alias.separator ? config.alias.separator : '') + (isNaN(attrValues[0]) ? attrValues[0].toLowerCase() : attrValues[0]);
                        }
                        else {
                            alias = alias + (isNaN(attrValues[0]) ? attrValues[0].toLowerCase() : attrValues[0]);
                        }
                    }
                }
            }
            else {
                if (typeof (metadata.alias) === 'object') {
                    alias = metadata.alias[0];
                }
                else {
                    alias = metadata.alias;
                }
            }
            return alias;
        }
    }
    goTo(url, relative = false, queryParams) {
        if (!queryParams) {
            queryParams = {};
        }
        if (!url) {
            this.location.back();
        }
        else {
            if (relative) {
                this.router.navigate([url], {
                    relativeTo: this.route,
                    queryParams: queryParams
                });
            }
            else {
                this.router.navigate([url], {
                    queryParams: queryParams
                });
            }
        }
    }
    static { this.ɵfac = function ConfigurationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfigurationService)(i0.ɵɵinject('env'), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.OAuthService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(CacheService), i0.ɵɵinject(i5.Location)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigurationService, factory: ConfigurationService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigurationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }, { type: i1.HttpClient }, { type: i2.OAuthService }, { type: i2$1.Router }, { type: i2$1.ActivatedRoute }, { type: CacheService }, { type: i5.Location }], null); })();

class ChartService {
    constructor(configService) {
        this.configService = configService;
    }
    getChartOptions() {
        let options = {
            chart: {
                type: 'line'
            },
            colors: this.configService.themes[this.configService.env.theme].palette,
            title: {},
            plotOptions: {},
            legend: {},
            credits: {
                enabled: false
            },
            xAxis: {
                title: {}
            },
            yAxis: {
                title: {}
            },
            exporting: {
                menuItemDefinitions: {
                    // Custom definition
                    label: {
                        onclick: function () {
                            this.renderer.label('You just clicked a custom menu item', 100, 100)
                                .attr({
                                fill: '#a4edba',
                                r: 5,
                                padding: 10,
                                zIndex: 10
                            })
                                .css({
                                fontSize: '1.5em'
                            })
                                .add();
                        },
                        text: 'Show label'
                    }
                },
                buttons: {
                    contextButton: {
                        menuItems: ['downloadPNG', 'downloadSVG', 'separator', 'label']
                    }
                }
            },
            series: [],
            tooltip: {
                useHTML: true,
                formatter: function () {
                    return '<span><b>' + this.x + ':</b>&nbsp;</span><span><b>' + this.y + "</b></span>";
                },
            },
        };
        return options;
    }
    static { this.ɵfac = function ChartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartService)(i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ChartService, factory: ChartService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChartService, [{
        type: Injectable
    }], () => [{ type: ConfigurationService }], null); })();

var SearchOptions;
(function (SearchOptions) {
    SearchOptions["IS"] = "is";
    SearchOptions["CONTAINS"] = "contains";
    SearchOptions["LIKE"] = "like";
})(SearchOptions || (SearchOptions = {}));

const PILL_SEARCH = 'pill search';
const OPTION_SEARCH = 'option search';
const SIMPLE_SEARCH = 'simple search';
const STANDARD_SEARCH = 'standard search';
const RANGE_SEARCH = 'range search';
const NUMBER_SEARCH = 'number search';
const UNIT_RANGE_SEARCH = 'unit range search';
class OptionSearch {
    constructor(parameter, value, option) {
        this.type = OPTION_SEARCH;
        this.parameter = parameter;
        this.queryValue = value;
        this.optionValue = option;
    }
}
class StandardSearch {
    constructor() {
        this.type = STANDARD_SEARCH;
    }
}
class SimpleSearch {
    constructor() {
        this.type = SIMPLE_SEARCH;
    }
}
class PillSearch {
    constructor() {
        this.type = PILL_SEARCH;
    }
}
class GeneralSearchParameter extends SimpleSearch {
    constructor(value) {
        super();
        this.parameter = null;
        this.value = value;
    }
}
class StandardSearchParameter extends StandardSearch {
    constructor(parameter, value) {
        super();
        this.parameter = parameter;
        this.value = value;
    }
}
class PillSearchParameter extends PillSearch {
    constructor(parameter, value) {
        super();
        this.parameter = parameter;
        this.value = value;
    }
}
class SimpleSearchParameter extends SimpleSearch {
    constructor(parameter, value) {
        super();
        this.parameter = parameter;
        this.value = value;
    }
}
class NumberSearchParameter {
    constructor(parameter, value) {
        this.type = NUMBER_SEARCH;
        this.parameter = parameter;
        this.value = value;
    }
}
class RangeSearch {
    constructor() {
        this.type = RANGE_SEARCH;
    }
}
class UnitRangeSearch {
    constructor() {
        this.type = UNIT_RANGE_SEARCH;
    }
}
class SearchOption {
    constructor(key, value) {
        this.key = key;
        this.value = value;
    }
}
class Filter {
}
var ViewTypeEnum;
(function (ViewTypeEnum) {
    ViewTypeEnum[ViewTypeEnum["TABLE"] = 0] = "TABLE";
    ViewTypeEnum[ViewTypeEnum["COMPONENT"] = 1] = "COMPONENT";
})(ViewTypeEnum || (ViewTypeEnum = {}));
class ResultList {
}
class ResultSearchEvent {
}
class SearchRequest {
}
class Results {
}
class AggregationInput {
}
class Aggregation {
}
class AggregationItem {
}
class SearchResponse {
}

class QueryBuilder {
    /*
    * Merge all the individual filter conditions into a single
    * @param keys individual filter conditions
    */
    concatenateOrConditions(keys) {
        return this.concatenateConditions(keys, 'OR');
    }
    /*
    * Merge all the individual filter conditions into a single
    * @param keys individual filter conditions
    */
    concatenateAndConditions(keys) {
        return this.concatenateConditions(keys, 'AND');
    }
    /*
    * Merge all the individual filter conditions into a single
    * @param keys individual filter conditions
    * @param mergeType merge Type
    */
    concatenateConditions(keys, mergeType) {
        let conditions = '(';
        keys.forEach((key, index) => {
            const trimmedKey = key.trim();
            const value = '%22'.concat(trimmedKey).concat('%22');
            if (index < (keys.length - 1)) {
                conditions = conditions.concat(value).concat(' ').concat(mergeType).concat(' ');
            }
            else {
                conditions = conditions.concat(value);
            }
        });
        return conditions.concat(')');
    }
    queryBuilder(searchParameters) {
        if (!searchParameters || searchParameters.length === 0) {
            return this.getEmptyQuery();
        }
        //Add language filter as OR
        return this.getQueryFromParameters(searchParameters);
    }
    getQueryFromParameters(parameters) {
        const queries = [];
        let sepLeft;
        let sepRight;
        parameters.forEach((parameter, index) => {
            let query = '';
            switch (parameter.type) {
                case STANDARD_SEARCH:
                    const standardSearchType = parameter;
                    //query = standardSearchType.parameter + ':"' + standardSearchType.value + '"';
                    if (standardSearchType.parameter === 'metadata.alias') {
                        query = 'metadata.alias:"' + standardSearchType.value + '"';
                    }
                    else {
                        query = this.getQueryParameter(standardSearchType.parameter, standardSearchType.value, null, '(', ')');
                    }
                    break;
                case SIMPLE_SEARCH:
                    const simpleSearchType = parameter;
                    if (simpleSearchType.value.includes('*')) {
                        sepLeft = '(';
                        sepRight = ')';
                    }
                    else if (!simpleSearchType.value.includes('(')) {
                        sepLeft = '(';
                        sepRight = ')';
                    }
                    else {
                        sepLeft = '';
                        sepRight = '';
                    }
                    query = this.getQueryParameter(simpleSearchType.parameter, simpleSearchType.value, null, sepLeft, sepRight);
                    break;
                case PILL_SEARCH:
                    const pillSearchType = parameter;
                    sepLeft = '"';
                    sepRight = '"';
                    query = this.getQueryParameter(pillSearchType.parameter, pillSearchType.value, null, sepLeft, sepRight);
                    break;
                case OPTION_SEARCH:
                    const optionSearchType = parameter;
                    query = this.getQueryParameter(optionSearchType.parameter, optionSearchType.queryValue, optionSearchType.optionValue, '(', ')');
                    break;
                case RANGE_SEARCH:
                    const rangeSearchType = parameter;
                    query = this.getRangeQueryParameter(rangeSearchType.parameter, rangeSearchType.rangeValue);
                    break;
                case NUMBER_SEARCH:
                    const numberSearchType = parameter;
                    query = this.getNumberParameter(numberSearchType.parameter, numberSearchType.value);
                    break;
                case UNIT_RANGE_SEARCH:
                    const unitRangeSearchType = parameter;
                    const unitRangeQueries = [];
                    unitRangeQueries.push(this.getQueryParameter(unitRangeSearchType.unitParameter, unitRangeSearchType.unitValue, null, '(', ')'));
                    unitRangeQueries.push(this.getRangeQueryParameter(unitRangeSearchType.rangeParameter, unitRangeSearchType.rangeValue));
                    query = unitRangeQueries.join(' AND ');
                    break;
                default:
                    query = null;
            }
            if (query) {
                queries.push(query);
            }
        });
        // join all the queries together
        return queries.join(' AND ');
    }
    getQueryParameter(key, value, option, separatorLeft, separatorRight) {
        let query = '';
        value = value + '';
        //value = value.replace(/[&|#=,$%.'`:<>{}]/g, '');
        //value = value.replace(/[&|#=$%'`{}]/g, '');
        value = value.replace(/[&|#$%'`{}]/g, '');
        value = value.replace(/[\/]/g, '\\\/'); // escaping /
        if (option) {
            value = this.includeSearchOption(value, option);
        }
        if (key) {
            query = query.concat(key).concat(':');
        }
        //return query.concat('(').concat(value).concat(')');
        return query.concat(separatorLeft).concat(value).concat(separatorRight);
    }
    getNumberParameter(key, number) {
        let query = ''.concat(key).concat(':').concat(number + '');
        return query;
    }
    getRangeQueryParameter(key, range) {
        range = range.replace(/[&\/\\|#=,()$%.'`:<>{}]/g, '');
        const values = range.split('_');
        const rangeValue = '['.concat(values[0]).concat(' TO ').concat(values[1]).concat(']');
        return key.concat(':').concat('(').concat(rangeValue).concat(')');
    }
    aggregationBuilder(aggregations) {
        let aggregationQuery = '';
        aggregations.forEach((key, index) => {
            if (index < (aggregations.length - 1)) {
                aggregationQuery = aggregationQuery.concat(key).concat(',');
            }
            else {
                aggregationQuery = aggregationQuery.concat(key);
            }
        });
        return aggregationQuery;
    }
    getEmptyQuery() {
        return '*';
    }
    includeSearchOption(value, option) {
        let formattedValue = '';
        switch (option) {
            case SearchOptions.IS:
                formattedValue = '"' + value + '"';
                break;
            case SearchOptions.CONTAINS:
                const words = value.split(' ');
                words.forEach((element, index) => {
                    if (element) {
                        formattedValue = formattedValue + element + '*';
                        if (index < words.length - 1) {
                            formattedValue = formattedValue + ' + ';
                        }
                    }
                });
                break;
            case SearchOptions.LIKE:
                formattedValue = value + '~';
                break;
            default:
                formattedValue = value;
        }
        return formattedValue;
    }
    searchQuery(searchParameters) {
        if (searchParameters && searchParameters.length > 0) {
            return this.queryBuilder(searchParameters);
        }
        else {
            return this.getEmptyQuery();
        }
    }
}

class LoggingService {
    constructor() { }
    static { this.ɵfac = function LoggingService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoggingService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoggingService, factory: LoggingService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoggingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

class UiSearch {
}
class SearchService {
    constructor(http, confirmationService, router, route, oauthService, loggingService, messageService, configService) {
        this.http = http;
        this.confirmationService = confirmationService;
        this.router = router;
        this.route = route;
        this.oauthService = oauthService;
        this.loggingService = loggingService;
        this.messageService = messageService;
        this.configService = configService;
        this.apiSearch = this.configService.env.servicesUrl + '/collection/';
        this.advancedSearchVisible = false;
        this.queryBuilder = new QueryBuilder();
    }
    getHeaders() {
        if (this.oauthService.getIdentityClaims()) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            });
        }
        else {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + this.configService.env.token
            });
        }
    }
    get(endpoint, responseType) {
        let headers = this.getHeaders();
        if (responseType) {
            if (responseType === 'blob') {
                return this.http.get(endpoint, { headers: headers, observe: 'response', responseType: responseType });
            }
            else {
                return this.http.get(endpoint, { headers: headers, responseType: responseType });
            }
        }
        else {
            return this.http.get(endpoint, { headers: headers });
        }
    }
    post(endpoint, payload, responseType) {
        let headers = this.getHeaders();
        if (responseType) {
            return this.http.post(endpoint, payload || {}, { headers: headers, responseType: responseType });
        }
        else {
            return this.http.post(endpoint, payload || {}, { headers: headers });
        }
    }
    put(endpoint, payload) {
        let headers = this.getHeaders();
        return this.http.put(endpoint, payload, { headers: headers });
    }
    delete(endpoint) {
        let headers = this.getHeaders();
        return this.http.delete(endpoint, { headers: headers });
    }
    /*
        Used to get single collection item
    */
    searchCollectionItemByAlias(space, collection, alias, lang, status, statuses) {
        let headers = this.getHeaders();
        return this.http.get(this.apiSearch + space + '/' + collection + '/search/alias?alias=' + alias + '&status=' + status + '&lang=' + this.configService.env.currentLang, { headers: headers });
    }
    searchCollectionItemById(space, collection, alias, lang, status, statuses) {
        let headers = this.getHeaders();
        return this.http.get(this.apiSearch + space + '/' + collection + '/documents/' + alias + '/status/' + status, { headers: headers });
    }
    /*
        Used to search between collection items
    */
    searchCollectionItems(space, collection, searchParameters, sizeParam, fromParam, sortParam, filterParam, fields, collapseBy, status, geoFilter, viewConfig) {
        if (!searchParameters) {
            searchParameters = [];
        }
        const query = this.queryBuilder.searchQuery(searchParameters);
        let searchRequest = {
            q: query,
            size: sizeParam
        };
        if (status) {
            searchRequest.status = status;
        }
        else {
            if (this.configService.env['statuses']) {
                searchRequest.status = this.configService.env['statuses'];
            }
        }
        //Must be enriched when it will be possibile to provide more than one geofilter for request
        if (geoFilter) {
            searchRequest.geoFilter = geoFilter;
        }
        if (viewConfig?.grouping?.groupedDisplay && viewConfig?.grouping?.aggs?.length > 0) {
            searchRequest.aggs = JSON.parse(JSON.stringify(viewConfig.grouping.aggs).replaceAll("%lang%", this.configService.env.currentLang));
            searchRequest.size = 0;
        }
        else if (viewConfig?.showFilterTerms && viewConfig?.facets?.length > 0) {
            searchRequest.aggs = [];
            for (let i = 0; i < viewConfig.facets.length; i++) {
                searchRequest.aggs.push(this.createFilterTermItem(viewConfig.facets[i]));
            }
            searchRequest.aggSize = 0;
            searchRequest.f = filterParam;
            searchRequest.from = fromParam === 0 || !fromParam ? 0 : fromParam - 1;
            searchRequest.sort = sortParam;
            searchRequest.collapseBy = collapseBy;
            searchRequest.fields = fields ? fields.toString() : null;
        }
        else {
            searchRequest.aggSize = 0;
            searchRequest.f = filterParam;
            searchRequest.from = fromParam === 0 || !fromParam ? 0 : fromParam - 1;
            searchRequest.sort = sortParam;
            searchRequest.collapseBy = collapseBy;
            searchRequest.fields = fields ? fields.toString() : null;
        }
        let headers = this.getHeaders();
        return this.http.post(this.apiSearch + space + '/' + collection + '/search', searchRequest, { headers: headers });
    }
    createFilterTermItem(term) {
        let agg = {
            "key": term.name,
            "size": 2000,
            "order": term.order || "ASC",
            "type": "TERMS"
        };
        if (term.concat) {
            agg.field = term.paths.length > 1 ? term.paths[1] : term.paths[0];
            agg.concatFields = term.paths;
        }
        else {
            if (term.paths) {
                agg.field = term.paths[0];
            }
        }
        return agg;
    }
    /* createAggItem(root: any, parent: any, terms: Array<any>, count: number, index: number, fields: Array<string>)
    {
        let level = parent;

        for(let i=0; i<index; i++)
        {
            level = level.aggs[0];
        }

        level.aggs = [];
        
        let agg;
        
        if (index <= count-1)
        {
            let path = terms[index].path?.replace("%lang%",this.configService.env.currentLang);

            agg = {
                "key": terms[index].name,
                "size": 2000,
                "order": terms[index].order || "ASC",
                "type": "TERMS"
            };

            if (path.includes("|")) {
                agg.field = path.split("|")[0];
                agg.concatFields = path.split("|");
            } else {
                agg.field = path;
            }
        }
        else {
            agg = {
                "key": "results",
                "fields": fields.concat(["metadata","status"]).toString(),
                "size": 1,
                "type": "TOP_HITS"
            };
        }

        level.aggs.push(agg);

        return root;
    } */
    manageError(err, msg) {
        if (err.code === 401 || err.status === 401) {
            if (this.oauthService.getIdentityClaims() && this.oauthService.getAccessTokenExpiration() < new Date().getTime()) {
                window.sessionStorage.clear();
                window.localStorage.clear();
                window.sessionStorage.clear();
                window.localStorage.clear();
                this.oauthService.setupAutomaticSilentRefresh();
                this.configService.logout(null, false);
                this.oauthService.redirectUri = window.location.href;
                this.oauthService.loadDiscoveryDocumentAndLogin();
            }
            else {
                if (err.error && err.error.error) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: msg + " - " + err.error.error.description });
                    this.loggingService.log = err.error.error.errors;
                }
                else {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: msg + " - " + err.message });
                }
            }
        }
        else if (err.code === 400 || err.status === 400) {
            if (err.error && err.error.error) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: msg + " - " + err.error.error.description });
                this.loggingService.log = err.error.error.errors;
            }
            else {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: msg + " - " + err.message });
            }
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: msg + " - " + err.message });
        }
    }
    static { this.ɵfac = function SearchService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2$2.ConfirmationService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(i2.OAuthService), i0.ɵɵinject(LoggingService), i0.ɵɵinject(i2$2.MessageService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SearchService, factory: SearchService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: i2$2.ConfirmationService }, { type: i2$1.Router }, { type: i2$1.ActivatedRoute }, { type: i2.OAuthService }, { type: LoggingService }, { type: i2$2.MessageService }, { type: ConfigurationService }], null); })();

class WorkspaceService {
    constructor(searchService, router, configService) {
        this.searchService = searchService;
        this.router = router;
        this.configService = configService;
    }
    getWorkspaces() {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace?onlyActive=true');
    }
    getWorkspace(code) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/' + code);
    }
    newWorkspace(form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace', form);
    }
    updateWorkspace(code, form) {
        return this.searchService.put(this.configService.env.servicesUrl + '/workspace/' + code, form);
    }
    deleteWorkspace(code) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/workspace/' + code);
    }
    getWorkflows(space) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow');
    }
    getWorkflow(space, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow/' + id);
    }
    newWorkflow(space, form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow', form);
    }
    updateWorkflow(space, code, form) {
        return this.searchService.put(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow/' + code, form);
    }
    deleteWorkflow(space, code) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow/' + code);
    }
    mapWorkspaces(res) {
        return res.workspaces.map(e => {
            let item = {};
            for (let key in e) {
                item[key] = e[key];
            }
            item.title = e.name || e.code;
            item.link = '/admin/spaces/' + e.code + "/" + this.configService.env.currentLang;
            item.image = e.image || './assets/images/noimagefound.jpg';
            if (e.roleType === 'ADMIN') {
                item.description = '<div class="align-right"><space-manager-button space="' + e.code + '"></space-manager-button></div>';
            }
            item.target = "_self";
            return item;
        });
    }
    setCurrentSpace(space, callback) {
        space = space || this.configService.env.space;
        if (!this.configService.env.spaces) {
            this.getWorkspaces().subscribe(res => {
                this.configService.env.roleType = res.roleType;
                if (res.workspaces) {
                    this.configService.env.spaces = this.mapWorkspaces(res);
                }
                else {
                    this.configService.env.spaces = [];
                }
                this.initSpace(space, callback);
            }, err => {
                this.searchService.manageError(err, 'Error extracting workspaces');
            });
        }
        else {
            this.initSpace(space, callback);
        }
    }
    initSpace(space, callback) {
        if (!space) {
            if (!this.router.url.includes("/home") && !this.router.url.includes("/docs")) {
                this.router.navigate(["/home" + "/" + this.configService.env.currentLang]);
            }
            else {
                if (this.configService.env.spaces.length > 0) {
                    this.configService.env.space = this.configService.env.spaces[0].code;
                    this.configService.env.roleType = this.configService.env.spaces[0].roleType;
                }
                if (callback) {
                    callback();
                }
            }
        }
        else {
            this.configService.env.space = this.getCurrentSpace(space).code;
            this.configService.env.roleType = this.getCurrentSpace(space).roleType;
            if (callback) {
                callback();
            }
        }
    }
    getCurrentSpace(space) {
        let index = this.configService.env.spaces.findIndex(item => item.code === (space || this.configService.env.space));
        if (index >= 0) {
            return this.configService.env.spaces[index];
        }
        else {
            return null;
        }
    }
    highlightCurrentSpace() {
        for (let i = 0; i < this.configService.env.spaces?.length; i++) {
            if (this.configService.env.spaces[i].code === this.configService.env.space) {
                this.configService.env.spaces[i].cssclass = "highlight";
            }
            else {
                this.configService.env.spaces[i].cssclass = null;
            }
        }
    }
    static { this.ɵfac = function WorkspaceService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WorkspaceService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WorkspaceService, factory: WorkspaceService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WorkspaceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: SearchService }, { type: i2$1.Router }, { type: ConfigurationService }], null); })();

class OptionsService {
    constructor(http, configService, workflowService, searchService) {
        this.http = http;
        this.configService = configService;
        this.workflowService = workflowService;
        this.searchService = searchService;
        this.FIELD_PREFIX = "document.";
        this.types = [
            {
                label: "Standard",
                value: "standard"
            }, {
                label: "Reference",
                value: "reference"
            }, {
                label: "External",
                value: "external"
            }, {
                label: "Internal",
                value: "internal"
            }
        ];
        this.methods = [
            {
                label: "GET",
                value: "GET"
            }, {
                label: "POST",
                value: "POST"
            }
        ];
    }
    getOptionLabel(option) {
        return option.label;
    }
    getSelectedOptions(options) {
        return options.selected;
    }
    getOption(dynamicForm, refOptionsId) {
        if (dynamicForm.options) {
            let options = dynamicForm.options.filter(item => item.id === refOptionsId);
            if (options.length > 0) {
                return options[0];
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
    getOptionItems(dynamicForm, refOptionsId) {
        if (dynamicForm.options) {
            let options = dynamicForm.options.filter(item => item.id === refOptionsId);
            if (options.length > 0) {
                if (options[0].type === 'standard' && options[0].items && options[0].refOptionsMappings && options[0].refOptionsMappings.length > 0) {
                    return options[0].items.map((e) => {
                        let item = {};
                        let labels = jsonPath.query(e, '$.' + options[0].refOptionsMappings[0].label);
                        let values = jsonPath.query(e, '$.' + options[0].refOptionsMappings[0].value);
                        let label = labels.length > 0 ? labels[0] : "";
                        let value = values.length > 0 ? values[0] : "";
                        item = {
                            value: value,
                            label: label
                        };
                        return item;
                    });
                }
                else {
                    return [];
                }
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }
    getOptionFields(dynamicForm, refOptionsId) {
        if (dynamicForm.options) {
            let options = dynamicForm.options.filter(item => item.id === refOptionsId);
            if (options.length > 0) {
                return options[0].fields || [];
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }
    getComponentSelectedOptions(dynamicForm, refOptionsId) {
        if (dynamicForm.options) {
            let options = dynamicForm.options.filter(item => item.id === refOptionsId);
            if (options.length > 0) {
                return options[0].selected || [];
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }
    getRemoteItems(statuses, dynamicFormControlService, dynamicForm, dynamicFormObject, parentForm, option, filters, userFilter, searchFilter) {
        if (option.type === 'reference' || option.type === 'standard') {
            return this.getReferenceItems(statuses, dynamicFormControlService, dynamicForm, dynamicFormObject, parentForm, option, option.fields, filters, userFilter, searchFilter);
        }
        else {
            return this.getExternalItems(dynamicFormControlService, dynamicForm, dynamicFormObject, parentForm, option, filters);
        }
    }
    getReferenceItems(statuses, dynamicFormControlService, dynamicForm, dynamicFormObject, parentForm, option, fields, filters, userFilter, searchFilter) {
        let payload = {
            "size": dynamicFormObject.componentConfig?.size || this.configService.env.options.maxSize,
            "aggSize": 0,
            "aggType": "flat",
            "from": 0
        };
        //Check if the reference option collection is a reference or a data
        if (this.configService.references[dynamicForm.space]?.length > 0) {
            let index = this.configService.references[dynamicForm.space].findIndex(item => item.collection === (option.type === 'standard' ? 'refoptions' : option.reference.collection));
            if (index < 0) {
                //This means that the collection is a data, not a reference, because it is not in the configService.references list
                //I need to set the statuses coming from the user profile
                if (this.configService.globalUserSpaceCollectionActions?.length > 0) {
                    let auths = this.configService.globalUserSpaceCollectionActions.filter(item => item.name === "*" || item.name === option.reference.collection);
                    if (auths.length >= 0) {
                        payload.status = auths[0].view?.toString();
                    }
                }
                else {
                    payload.status = statuses.allStatus?.toString();
                }
            }
        }
        if (option.sort) {
            payload.sort = option.sort.startsWith(this.FIELD_PREFIX) ? option.sort : this.FIELD_PREFIX + option.sort;
        }
        else {
            if (dynamicFormObject.refOptionsMappings) {
                payload.sort = dynamicFormObject.refOptionsMappings.label.startsWith(this.FIELD_PREFIX) ? dynamicFormObject.refOptionsMappings.label : this.FIELD_PREFIX + dynamicFormObject.refOptionsMappings.label;
            }
            else {
                if (option.type === 'standard') {
                    payload.sort = "document.label:ASC";
                }
            }
        }
        let q = "";
        //Extraction of possible filters coming from user profile
        let optionUserFilters;
        let optionUserFiltersIndex = this.configService.globalUserParams?.findIndex(item => ((item.collection === "*" || item.collection === dynamicForm.collection) && item.field === 'document.' + dynamicFormObject.pathId));
        if (optionUserFiltersIndex >= 0) {
            optionUserFilters = this.configService.globalUserParams[optionUserFiltersIndex];
        }
        if (option.type === 'standard') {
            q = "document.type:" + option.id;
            //Filter applied due to the user profile filters
            if (optionUserFilters) {
                q = q + " AND document.key:(" + optionUserFilters.value + ")";
            }
            payload.fields = "document";
        }
        else {
            //Filter applied due to the user profile filters
            if (optionUserFilters && !dynamicFormObject.refOptionsFilters && dynamicFormObject.refOptionsMappings) {
                q = dynamicFormObject.refOptionsMappings.value.startsWith(this.FIELD_PREFIX) ? dynamicFormObject.refOptionsMappings.value : this.FIELD_PREFIX + dynamicFormObject.refOptionsMappings.value + ":(" + optionUserFilters.value + ")";
            }
            //In case of presence of external forms, if the reference points to an external form I must provide statuses coming from user profile view action
            if (dynamicForm.externalFormsRefList?.length > 0 && dynamicForm.externalFormsRefList?.includes(option.reference.collection)) {
                if (this.configService.globalUserSpaceCollectionActions?.length > 0) {
                    let auths = this.configService.globalUserSpaceCollectionActions.filter(item => item.name === "*" || item.name === option.reference.collection);
                    if (auths.length >= 0) {
                        payload.status = auths[0].view?.toString();
                    }
                }
            }
            payload.fields = fields ? fields.map(a => (a.name.startsWith(this.FIELD_PREFIX) ? a.name : this.FIELD_PREFIX + a.name)).toString() : "";
        }
        if (searchFilter || userFilter || (filters && filters.length > 0)) {
            if (filters && filters.length > 0) {
                for (let i = 0; i < filters.length; i++) {
                    let formulaValue;
                    if (dynamicFormObject.refOptionsFilters[i].value) {
                        formulaValue = dynamicFormControlService.executeFormula(dynamicFormObject.refOptionsFilters[i].value, parentForm, dynamicForm.acceptedParams, dynamicForm.params);
                    }
                    else {
                        formulaValue = dynamicFormObject.refOptionsFilters[i].defaultValue;
                    }
                    if (formulaValue != undefined) {
                        let field = (filters[i].field.includes(this.FIELD_PREFIX) ? filters[i].field : this.FIELD_PREFIX + filters[i].field);
                        if (q > '' && q !== "*") {
                            q = q + ' AND ' + field + ':(' + formulaValue + ')';
                        }
                        else {
                            q = field + ':(' + formulaValue + ')';
                        }
                    }
                    else {
                        if (q === '') {
                            q = "*";
                        }
                    }
                }
            }
            if (userFilter) {
                for (let f in userFilter) {
                    if (userFilter[f]) {
                        if (f === dynamicFormObject.code) {
                            let field = dynamicFormObject.refOptionsMappings?.value;
                            if (q > '' && q !== "*") {
                                q = q + ' AND ' + (field.startsWith(this.FIELD_PREFIX) ? field : this.FIELD_PREFIX + field) + ':(' + userFilter[f].value + ')';
                            }
                            else {
                                q = (field.startsWith(this.FIELD_PREFIX) ? field : this.FIELD_PREFIX + field) + ':(' + userFilter[f].value + ')';
                            }
                        }
                        else {
                            let index = dynamicFormObject.components.findIndex(item => item.code === f);
                            if (index >= 0) {
                                let field = dynamicFormObject.components[index].refOptionsMappings.groupColumn;
                                if (q > '' && q !== "*") {
                                    q = q + ' AND ' + (field.startsWith(this.FIELD_PREFIX) ? field : this.FIELD_PREFIX + field) + ':(' + userFilter[f].value + ')';
                                }
                                else {
                                    q = (field.startsWith(this.FIELD_PREFIX) ? field : this.FIELD_PREFIX + field) + ':(' + userFilter[f].value + ')';
                                }
                            }
                        }
                    }
                }
            }
            if (searchFilter) {
                let field = dynamicFormObject.refOptionsMappings.label;
                if (q > '' && q !== "*") {
                    q = q + ' AND ' + (field.startsWith(this.FIELD_PREFIX) ? field : this.FIELD_PREFIX + field) + ':(*' + searchFilter + '*)';
                }
                else {
                    q = (field.startsWith(this.FIELD_PREFIX) ? field : this.FIELD_PREFIX + field) + ':(*' + searchFilter + '*)';
                }
            }
        }
        else {
            if (q === '') {
                q = "*";
            }
        }
        payload.q = q > "" ? q : "*";
        let headers = this.getReferenceHeaders();
        let url;
        if (option.type === 'standard') {
            url = this.configService.env.servicesUrl + '/collection/' + (option.reference?.space || dynamicForm.space) + '/refoptions/search';
        }
        else {
            url = this.configService.env.servicesUrl + '/collection/' + (option.reference?.space || dynamicForm.space) + '/' + option.reference.collection + '/search';
        }
        return this.http.post(url, payload, { headers: headers });
    }
    getExternalItems(dynamicFormControlService, dynamicForm, dynamicFormObject, parentForm, connection, filters) {
        let headers = {};
        if (connection.external.headers) {
            for (let i = 0; i < connection.external.headers.length; i++) {
                headers[connection.external.headers[i].name] = connection.external.headers[i].value;
            }
        }
        let payload;
        if (connection.external.method === 'POST') {
            payload = JSON.parse(JSON.stringify(connection.payload));
        }
        else {
            payload = JSON.parse(JSON.stringify(connection.params));
        }
        /* Extraction of the filters and enrichment of the payload */
        if (filters && filters.length > 0) {
            for (let i = 0; i < filters.length; i++) {
                let formulaValue;
                if (dynamicFormObject.refOptionsFilters[i].value) {
                    formulaValue = dynamicFormControlService.executeFormula(dynamicFormObject.refOptionsFilters[i].value, parentForm, dynamicForm.acceptedParams, dynamicForm.params);
                }
                else {
                    formulaValue = dynamicFormObject.refOptionsFilters[i].defaultValue;
                }
                payload[filters[i].field] = formulaValue;
            }
        }
        /* ------------------------------------------------ */
        if (connection.external.method === 'POST') {
            return this.http.post(connection.external.endPoint, payload, { headers: headers });
        }
        else {
            return this.http.get(connection.external.endPoint, { params: connection.params > '' ? JSON.parse(payload) : null, headers: headers });
        }
    }
    getReferenceHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'Bearer ' + (this.configService.user || this.configService.env.token)
        });
    }
    getRemoteItemFields(option, res) {
        if (option.type === 'reference' || option.type === 'standard') {
            return this.getReferenceItemFields(option, res);
        }
        else {
            return this.getExternalItemFields(option, res);
        }
    }
    getExternalItemFields(option, items) {
        let fields = [];
        if (items.length > 0) {
            for (let key in items[0]) {
                fields.push(key);
            }
        }
        return fields;
    }
    getReferenceItemFields(option, items) {
        let fields = [];
        if (items.length > 0) {
            for (let key in items[0]) {
                if (key.startsWith(this.FIELD_PREFIX)) {
                    fields.push(key);
                }
                else {
                    fields.push(this.FIELD_PREFIX + key);
                }
            }
        }
        return fields;
    }
    uniqForObject(array) {
        const result = [];
        for (const item of array) {
            const found = result.some((value) => _.isEqual(value, item));
            if (!found) {
                result.push(item);
            }
        }
        return result;
    }
    isFilterEmpty(filter) {
        if (!filter) {
            return true;
        }
        for (let key in filter) {
            if (filter[key]) {
                return false;
            }
        }
        return true;
    }
    mapItems(items, mapping, unique, filter, control, controls) {
        //I initialize the array with all the items and then I will go filtering them depending on the filter object
        let oldItems = items ? JSON.parse(JSON.stringify(items)) : [];
        //If a filter is provided, I appli a logic to filter the items
        if (!this.isFilterEmpty(filter)) {
            oldItems = oldItems.filter((e) => {
                //I start from the fact that an item must not be added to the filtered list, and then I apply the logic to see If it must be added or not
                let allowed = false;
                //I loop through the filter keys
                for (let key in filter) {
                    //I don't take into consideration the filter key corresponding to the control that I am processing, 
                    //otherwise I get a list with just one element, the one inside the filter
                    if (key !== control.code) {
                        //I extract the data field corresponding to the filter key that I am checking
                        let keyField = control.refOptionsMappings.value;
                        //I compare the filter value with the field value of the current data item of the loop
                        //I add the data item to the output if the filter value is null or if it is equals to the corresponding data item field value            
                        let values = jsonPath.query(e, '$.' + (keyField.startsWith(this.FIELD_PREFIX) ? keyField : this.FIELD_PREFIX + keyField));
                        let value;
                        if (values.length > 0) {
                            value = values[0];
                        }
                        if (value === filter[control.code].value) {
                            allowed = true;
                        }
                        //Example: filter key = category data field = strCategory
                        //If filter[category] === e[strCategory] or filter[category] is null, the data item can be added to the list
                    }
                }
                return allowed;
            });
        }
        let newItems = oldItems.map(e => {
            let labels = jsonPath.query(e, '$.' + (mapping.label.startsWith(this.FIELD_PREFIX) ? mapping.label : this.FIELD_PREFIX + mapping.label));
            let values = jsonPath.query(e, '$.' + (mapping.label.startsWith(this.FIELD_PREFIX) ? mapping.value : this.FIELD_PREFIX + mapping.value));
            let label = labels.length > 0 ? labels[0] : "";
            let value = values.length > 0 ? values[0] : "";
            let item = {
                value: value,
                label: label
            };
            return item;
        });
        if (unique) {
            return this.uniqForObject(newItems);
        }
        return newItems;
    }
    mapRemoteItems(option, res, mapping) {
        if (mapping?.label.includes("%lang%")) {
            mapping.label = mapping.label.replace("%lang%", this.configService.env.currentLang);
        }
        if (mapping?.value.includes("%lang%")) {
            mapping.value = mapping.value.replace("%lang%", this.configService.env.currentLang);
        }
        if (option.type === 'reference' || option.type === 'standard') {
            return this.mapReferenceItems(option, res, mapping);
        }
        else {
            return this.mapExternalItems(option, res, mapping);
        }
    }
    mapReferenceItems(option, res, mapping) {
        let items;
        /*     if (res?.results?.values?.length > this.configService.env.options.maxSize) {
              items = res.results.values.slice(0, this.configService.env.options.maxSize);
            } else { */
        if (res.results?.values) {
            items = res.results.values;
        }
        else {
            items = [];
        }
        /*     } */
        if (!option.fields || option.fields.length === 0) {
            option.fields = this.getReferenceItemFields(option, items);
        }
        if (mapping) {
            items = this.mapItems(items, mapping);
        }
        return items;
    }
    mapExternalItems(option, res, mapping) {
        let items = [];
        if (option.external.listProperty) {
            let list = jsonPath.query(res, '$.' + option.external.listProperty);
            if (list.length > 0) {
                if (list[0].length > 20) {
                    items = list[0].slice(0, 20);
                }
                else {
                    items = list[0];
                }
            }
        }
        else {
            if (res.length > 0) {
                if (res.length > 20) {
                    items = res.slice(0, 20);
                }
                else {
                    items = res;
                }
            }
        }
        if (!option.fields || option.fields.length === 0) {
            option.fields = this.getExternalItemFields(option, items);
        }
        if (mapping) {
            items = this.mapItems(items, mapping);
        }
        return items;
    }
    getItemFieldValue(item, field) {
        let values = jsonPath.query(item, '$.' + field.name);
        if (values.length > 0) {
            return values[0];
        }
        else {
            return '';
        }
    }
    static { this.ɵfac = function OptionsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OptionsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(WorkspaceService), i0.ɵɵinject(SearchService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OptionsService, factory: OptionsService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OptionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: ConfigurationService }, { type: WorkspaceService }, { type: SearchService }], null); })();

class DynamicFormService {
    constructor(http, dialogService, optionService) {
        this.http = http;
        this.dialogService = dialogService;
        this.optionService = optionService;
        this.controlTypes = [
            'text',
            'textarea',
            'number',
            'checkbox',
            'select',
            'multiselect',
            'truefalse',
            'separator',
            'radiolist',
            'title',
            'subtitle',
            'label',
            'latlong',
            'datetime',
            'image',
            'video',
            'sequence',
            'system',
            'json',
            'code',
            'geogeometry',
            'geopoint',
            'geoline',
            'geopolygon'
        ];
        this.formTypes = [
            {
                label: "Internal",
                value: "internal"
            }, {
                label: "External",
                value: "external"
            }
        ];
        this.codeModes = [
            {
                label: "Html",
                value: "html"
            }, {
                label: "Javascript",
                value: "javascript"
            }
        ];
        this.formats = [
            {
                label: "Vertical",
                value: "vertical"
            }, {
                label: "Horizontal",
                value: "horizontal"
            }, {
                label: "Float",
                value: "float"
            }
        ];
    }
    getRootForm(dynamicForm) {
        if (!dynamicForm.components) {
            dynamicForm.components = [];
        }
        return dynamicForm.components;
    }
    getForm(dynamicForm, id) {
        if (!dynamicForm.forms) {
            dynamicForm.forms = [];
        }
        let forms = jsonPath.query(dynamicForm.forms, '$..[?(@.id==\'' + id + '\')]');
        if (forms.length > 0) {
            return forms[0];
        }
        else {
            forms = jsonPath.query(dynamicForm.forms, '$..[?(@.id==\'' + id + '\')]');
            if (forms.length > 0) {
                return forms[0];
            }
            else {
                return {};
            }
        }
    }
    addRootForm(dynamicForm, components) {
        if (!dynamicForm.components) {
            dynamicForm.components = [];
        }
    }
    addNestedForm(dynamicForm, nestedForm) {
        let index = dynamicForm.forms.findIndex(item => item.id === nestedForm.id);
        if (index < 0) {
            dynamicForm.forms.push(nestedForm);
        }
        else {
            dynamicForm.forms[index] = nestedForm;
        }
    }
    removeNestedForm(dynamicForm, refFormId) {
        delete dynamicForm.forms[refFormId];
        let index = dynamicForm.forms.findIndex(item => item.id === refFormId);
        if (index >= 0) {
            dynamicForm.forms.splice(index, 1);
        }
    }
    getNestedFormChildren(dynamicForm, id) {
        let form = this.getForm(dynamicForm, id);
        if (form) {
            return this.getRootForm(form).filter(item => item.type !== 'system');
        }
        else {
            return [];
        }
    }
    setNestedFormChildren(dynamicForm, id, children) {
        let form = this.getForm(dynamicForm, id);
        if (form) {
            form.components = children;
        }
    }
    getComponentChildren(dfo) {
        return dfo.components || [];
    }
    setComponentChildren(dfo, components) {
        dfo.components = components;
    }
    /**
     * Function that checks all the components of a form, at all the levels of the hierarchy, to find duplicates in the same level,
     * this means components with the same code, that cause problems to the form rendering
     *
     * @param dynamicForm
     */
    checkForm(dynamicForm) {
        dynamicForm.components = this.checkFormComponents(dynamicForm, this.getRootForm(dynamicForm));
        return dynamicForm;
    }
    checkFormComponents(dynamicForm, components) {
        let items = [];
        if (components) {
            for (let i = 0; i < components.length; i++) {
                if (components[i].visible === undefined) {
                    components[i].visible = true;
                }
                let duplicates = items.filter(item => item.id !== components[i].id && item.code === components[i].code);
                if (duplicates.length > 0) {
                    console.log("Found duplicate " + components[i].id + " - " + components[i].code + ' - ' + components[i].type);
                    /* Commented because it was blocking form loading */
                    /* for(let j=0; j<duplicates.length; j++)
                    {
                      if (duplicates[j].type === components[i].type)
                      {
                        if (duplicates[j].refOptionsId) {
                          components[i].refOptionsId = duplicates[j].refOptionsId;
                        } else if (duplicates[j].refFormId) {
                          components[i].refFormId = duplicates[j].refFormId;
                        }
          
                        items.push(components[i]);
          
                        this.setNestedFormChildren(dynamicForm, components[i].refFormId, this.checkForm(this.getForm(dynamicForm, components[i].refFormId)).components);
          
                        this.setComponentChildren(components[i],this.checkFormComponents(dynamicForm, this.getComponentChildren(components[i])));
                      }
                    } */
                }
                else {
                    items.push(components[i]);
                    this.setNestedFormChildren(dynamicForm, components[i].refFormId, this.checkForm(this.getForm(dynamicForm, components[i].refFormId)).components);
                    this.setComponentChildren(components[i], this.checkFormComponents(dynamicForm, this.getComponentChildren(components[i])));
                }
            }
        }
        return items;
    }
    classifyHierarchy(df) {
        for (let i = 0; i < this.getComponentChildren(df).length; i++) {
            this.getComponentChildren(df)[i].pos = i;
            this.getComponentChildren(df)[i] = this.classifyElement(this.getComponentChildren(df)[i], null);
        }
        return df;
    }
    classifyElement(dfo, parent) {
        var numberofdfc;
        var numberofdfa;
        if (dfo.type === "group") {
            if (!parent) {
                numberofdfc = this.getComponentChildren(dfo).filter(item => this.controlTypes.includes(item.type) && !item.formulaValue).length;
                numberofdfa = this.getComponentChildren(dfo).filter(item => item.type === "array").length;
                if (numberofdfc > 0 || numberofdfa > 0) {
                    dfo.category = "leaf";
                }
                else {
                    dfo.category = "level";
                }
            }
            else if (parent.category === "level") {
                numberofdfc = this.getComponentChildren(dfo).filter(item => this.controlTypes.includes(item.type) && !item.formulaValue).length;
                numberofdfa = this.getComponentChildren(dfo).filter(item => item.type === "array").length;
                if (numberofdfc > 0 || numberofdfa > 0) {
                    dfo.category = "leaf";
                }
                else {
                    dfo.category = "level";
                }
            }
            else {
                if (dfo.formulaValue) {
                    dfo.category = "scoring";
                }
                else {
                    dfo.category = "standard";
                }
            }
        }
        else {
            if (dfo.formulaValue) {
                dfo.category = "scoring";
            }
            else {
                dfo.category = "standard";
            }
        }
        if (this.getComponentChildren(dfo)) {
            for (let i = 0; i < this.getComponentChildren(dfo).length; i++) {
                var child = this.getComponentChildren(dfo)[i];
                child.pos = i;
                child = this.classifyElement(child, dfo);
            }
        }
        return dfo;
    }
    static { this.ɵfac = function DynamicFormService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2$3.DialogService), i0.ɵɵinject(OptionsService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DynamicFormService, factory: DynamicFormService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: i2$3.DialogService }, { type: OptionsService }], null); })();

class CollectionService {
    constructor(searchService, dynamicFormService, configService) {
        this.searchService = searchService;
        this.dynamicFormService = dynamicFormService;
        this.configService = configService;
    }
    createNewCollection(space) {
        return {
            space: space,
            tag: "data",
            formType: "MAIN",
            formConfig: {}
        };
    }
    getCollections(space, type, tag) {
        let url = this.configService.env.servicesUrl + '/collection/design/' + space + '/tags/' + (tag || 'data');
        if (type) {
            url = url + '?formType=' + type;
        }
        return this.searchService.get(url);
    }
    addSystemComponents(form) {
        if (!this.dynamicFormService.getRootForm(form)) {
            this.dynamicFormService.addRootForm(form);
        }
    }
    async computeExternalFormsReferences(parentDynamicForm, dynamicForm) {
        let components = jsonPath.query(this.dynamicFormService.getRootForm(dynamicForm), "$..[?(@.refFormId !== null && @.refFormId !== '' && @.refFormType==\'external\')]");
        for (let i = 0; i < components.length; i++) {
            let df = await this.getCollection(dynamicForm.space, components[i].refFormId).toPromise();
            df.externalFormsRefList = [];
            parentDynamicForm = await this.computeExternalFormsReferences(parentDynamicForm, df);
        }
        parentDynamicForm.externalFormsRefList = parentDynamicForm.externalFormsRefList.concat(components.map(e => {
            return e.refFormId;
        }));
        return parentDynamicForm;
    }
    saveNewCollection(form) {
        if (!form.cloned) {
            this.addSystemComponents(form);
        }
        return this.saveCollection(form.space, form);
    }
    getCollection(space, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + id);
    }
    saveCollection(space, form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/design/' + space, form);
    }
    updateCollection(space, form) {
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + form.collection, form);
    }
    deleteCollection(space, form) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + form.collection);
    }
    saveCollectionConfig(space, collection, config) {
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/collectionconfig', config);
    }
    getCollectionConfig(space, collection) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/collectionconfig');
    }
    updateCollectionConfig(space, collection, config) {
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/collectionconfig', config);
    }
    deleteCollectionConfig(space, collection) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/collectionconfig');
    }
    static { this.ɵfac = function CollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CollectionService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(DynamicFormService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CollectionService, factory: CollectionService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollectionService, [{
        type: Injectable
    }], () => [{ type: SearchService }, { type: DynamicFormService }, { type: ConfigurationService }], null); })();

class DynamicFormObject {
    constructor(options = {}) {
        this.pos = options.pos;
        this.pathId = options.pathId;
        this.type = options.type;
        this.category = options.category;
        this.enabled = options.enabled;
        this.required = options.required || false;
        this.collapsed = options.collapsed || true;
        this.visible = options.visible || true;
        this.containerCssClass = options.containerCssClass;
        this.cssClass = options.cssClass;
        this.code = options.code;
        this.value = options.value;
        this.step = options.step;
        this.multipleValues = options.multipleValues;
        this.displayFormat = options.displayFormat || "";
        this.hideIf = options.hideIf || "";
        this.showIf = options.showIf || "";
        this.formulaValue = options.formulaValue || "";
        this.mode = options.mode || "html";
        this.refOptionsId = options.refOptionsId || "";
        this.refOptionsMappings = options.refOptionsMappings;
        this.refOptionsFilters = options.refOptionsFilters || [];
        this.joinOptions = options.joinOptions || [];
        this.datasourceId = options.datasourceId || "";
        this.refFormId = options.refFormId;
        this.refFormType = options.refFormType;
        this.refPropertiesId = options.refPropertiesId;
        this.components = options.components;
        this.validation = options.validation || {};
        this.componentConfig = options.componentConfig || {};
        this.saved = options.saved;
        this.new = options.new;
        this.displayFields = options.displayFields || [];
        this.displayTemplate = options.displayTemplate;
        this.params = options.params;
        this.editableIf = options.editableIf;
        this.isIndexed = options.isIndexed;
        this.isIndexedAsKeyword = options.isIndexedAsKeyword;
        this.isIndexedAsFlat = options.isIndexedAsFlat;
        this.indexWeight = options.indexWeight;
        this.format = options.format;
        this.resetData = options.resetData;
        this.editBlocked = options.editBlocked;
    }
}

function customValidator(df, dfo, dynamicFormControlService, rootFormGroup, xpath) {
    /*
        Date (YYYY-MM-DD) - ^\d{4}-\d{2}-\d{2}$
        Date (MM/DD/YYYY) - ^\d{2}/\d{2}/\d{4}$
        Date (M|MM/D|DD/19|20YY) - ^(0?[1-9]|1[0-2])[\/](0?[1-9]|[12]\d|3[01])[\/](19|20)\d{2}$
        USD Currency Symbol  - ^(\$)(\d)+
        Euro Currency Symbol - ^(\€)(\d)+
        IPv4 - \b(?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.){3}(?:(?:2([0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))\b
        Phone number - ^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$
        Email - ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$
        Email (ex. max 80 chars) - ^(?=.{1,81}$)[\w\.-]+@[\w\.-]+\.\w{2,4}$
        Alphabetic Text - ^[a-zA-Z]+$
        Alphanumeric Text - ^[a-zA-Z0-9]+$
        Alphanumeric with spaces (ex 20 chars) - ^[\w\d\s]{1,20}$
        Alphanumeric no spaces (ex 250 chars) - ^\w{1,250}$
        URL - ^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$
        Number - ^-?\d+$
        Postive Int - ^\d+$
        Decimal Number - ^-?\d*\.?\d+$
    */
    const formats = {
        date1: "^\d{4}-\d{2}-\d{2}$",
        date2: "^\d{2}/\d{2}/\d{4}$",
        date3: "^(0?[1-9]|1[0-2])[\/](0?[1-9]|[12]\d|3[01])[\/](19|20)\d{2}$",
        usd: "^(\$)(\d)+",
        euro: "^(\€)(\d)+",
        ipv4: "\b(?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.){3}(?:(?:2([0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))\b",
        phoneNumber: "^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$",
        email: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$",
        email80: "^(?=.{1,81}$)[\w\.-]+@[\w\.-]+\.\w{2,4}$",
        alphatext: "^[a-zA-Z]+$",
        alpha: "^[a-zA-Z0-9]+$",
        alphaSpaces: "^[\w\d\s]{1,20}$",
        alphaNospaces: "^\w{1,250}$",
        url: "^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$",
        number: "^-?\d+$",
        positiveInt: "^\d+$",
        decimal: "^-?\d*\.?\d+$"
    };
    return (control) => {
        let validationErrors = {};
        for (let key in dfo.validation) {
            try {
                switch (key) {
                    case "validationRegex":
                        let regexp1 = dfo.validation[key];
                        let out = regexp1.test(control.value);
                        if (!out) {
                            validationErrors[key] = true;
                        }
                        break;
                    case "min":
                        if (!control.value || control.value.length < dfo.validation.min) {
                            validationErrors[key] = true;
                        }
                        break;
                    case "max":
                        if (control.value.length > dfo.validation.max) {
                            validationErrors[key] = true;
                        }
                        break;
                    case "validationFormat":
                        let regexp2 = formats[dfo.validation[key]];
                        let out2 = regexp2.test(control.value);
                        if (!out2) {
                            validationErrors[key] = true;
                        }
                        break;
                }
            }
            catch (error) {
                console.log(dfo.code + ' - ' + dfo.validation[key].formula + ' - ' + error.code + ' - ' + error.message);
            }
        }
        return validationErrors;
    };
}

class DynamicFormControlService {
    constructor(http, dynamicFormService, optionService, configService) {
        this.http = http;
        this.dynamicFormService = dynamicFormService;
        this.optionService = optionService;
        this.configService = configService;
        this.settings = {};
        this.init();
    }
    init() { }
    getKeyselectComponents(xpath) {
        return [
            {
                type: "select",
                code: "key",
                visible: true,
                pathId: xpath + ".key",
                parentType: "keyselect"
            },
            {
                type: "select",
                code: "result",
                visible: true,
                pathId: xpath + ".result",
                parentType: "keyselect"
            }
        ];
    }
    generateString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    getXpath(dfo, xpath) {
        return (xpath ? xpath + '.' : '') + (dfo.code || '');
    }
    getComponentClass(parentForm, dynamicForm, dynamicFormObject, xpath, debug) {
        let visible = this.processVisibilityConditions(dynamicForm, dynamicFormObject, parentForm.getRawValue(), xpath);
        if (debug) {
            return visible ? 'debug-box' : 'debug-highlight';
        }
        else {
            return visible ? ((xpath > '' || (!(xpath > '') && dynamicFormObject.type === 'form')) ? 'effect' : '') : 'hidden';
        }
    }
    getFormKeys(dynamicForm) {
        let keys = [];
        keys = this.addJoinOptionsFields(dynamicForm, keys, dynamicForm?.joinOptions);
        keys = this.flattenComponents(dynamicForm, keys, this.dynamicFormService.getRootForm(dynamicForm));
        return keys;
    }
    addJoinOptionsFields(dynamicForm, keys, joinOptions, code, pathId) {
        if (joinOptions?.length > 0) {
            for (let k = 0; k < joinOptions.length; k++) {
                let option = this.optionService.getOption(dynamicForm, joinOptions[k].refOptionsId);
                if (option && option.fields && option.fields.length > 0) {
                    for (let m = 0; m < option.fields.length; m++) {
                        let path = (pathId > '' ? pathId + '.' : '');
                        if (code) {
                            path = path + code + '.';
                        }
                        path = path + option.fields[m].name;
                        keys.push({
                            label: path,
                            value: 'document.' + path
                        });
                    }
                }
            }
        }
        return keys;
    }
    flattenComponents(dynamicForm, keys, components, pathId) {
        if (!keys) {
            keys = [];
        }
        if (!pathId) {
            pathId = '';
        }
        for (let i = 0; i < components.length; i++) {
            if (components[i].type === 'form' && components[i].refFormType == 'internal') {
                let nestedFormComponents = this.dynamicFormService.getNestedFormChildren(dynamicForm, components[i].refFormId);
                if (nestedFormComponents) {
                    let path = (pathId > '' ? pathId + '.' : '');
                    path = path + components[i].code;
                    keys.push({
                        label: path,
                        value: 'document.' + path
                    });
                    keys = this.flattenComponents(dynamicForm, keys, nestedFormComponents, path);
                }
            }
            else if (components[i].refOptionsId) {
                let path = (pathId > '' ? pathId + '.' : '');
                path = path + components[i].code;
                keys.push({
                    label: path + '.label',
                    value: 'document.' + path + '.label'
                });
                keys.push({
                    label: path + '.value',
                    value: 'document.' + path + '.value'
                });
            }
            else {
                let path = (pathId > '' ? pathId + '.' : '');
                path = path + components[i].code;
                keys.push({
                    label: path,
                    value: 'document.' + path
                });
                if (components[i].components) {
                    keys = this.flattenComponents(dynamicForm, keys, components[i].components, path);
                }
            }
            keys = this.addJoinOptionsFields(dynamicForm, keys, components[i]?.joinOptions, components[i].code, pathId);
        }
        return keys;
    }
    getInternalListComponents(dynamicForm) {
        let listComponents = [];
        listComponents = this.flattenListComponents(dynamicForm, listComponents, this.dynamicFormService.getRootForm(dynamicForm));
        return listComponents;
    }
    flattenListComponents(dynamicForm, listComponents, components) {
        if (!listComponents) {
            listComponents = [];
        }
        for (let i = 0; i < components.length; i++) {
            if ((components[i].type === 'multiselect' || components[i].type === 'checkboxlist') || (components[i].type === 'select' && components[i].multipleValues === true)) {
                listComponents.push(components[i]);
                if (components[i].components) {
                    listComponents = this.flattenListComponents(dynamicForm, listComponents, components[i].components);
                }
            }
        }
        return listComponents;
    }
    dropControl(e, dynamicForm, children, index, xpath) {
        if (e.data === undefined) {
            return;
        }
        if (e.data.stack === undefined) {
            var item = JSON.parse(JSON.stringify(e.data));
            item.new = true;
            item.saved = false;
            item.pathId = (xpath > '' ? xpath + '.' : dynamicForm.collection + '.') + (index || children.length);
            children.splice(index || children.length, 0, item);
            return true;
        }
        return false;
    }
    getRequiredPropertyName() {
        let required = this.configService.env.defaultControlProperties.filter(item => item.required === true);
        return required.map((item) => item.value);
    }
    isRequired(name) {
        if (this.getRequiredPropertyName().includes(name)) {
            return true;
        }
        else {
            return false;
        }
    }
    getHeader(dynamicForm, dynamicFormObject, data, xpath, externalForm, status, statuses) {
        let label = '';
        if (dynamicFormObject.displayTemplate) {
            if (dynamicFormObject.type === 'array' || dynamicFormObject.type === 'group' || dynamicFormObject.type === 'groupselect') {
                try {
                    label = this.executeFormula(dynamicFormObject.displayTemplate, data, dynamicForm.acceptedParams, dynamicForm.params);
                }
                catch (error) {
                    console.log(dynamicFormObject.code + ' - ' + dynamicFormObject.formulaValue + ' - ' + error.code + ' - ' + error.message);
                }
            }
            else if (dynamicFormObject.type === 'form') {
                if (dynamicFormObject.refFormType === 'external') {
                    try {
                        label = this.executeFormula(dynamicFormObject.displayTemplate, data, externalForm.acceptedParams, externalForm.params);
                    }
                    catch (error) {
                        console.log(dynamicFormObject.code + ' - ' + dynamicFormObject.formulaValue + ' - ' + error.code + ' - ' + error.message);
                    }
                }
                else {
                    label = this.executeFormula(dynamicFormObject.displayTemplate, data, dynamicForm.acceptedParams, dynamicForm.params);
                }
            }
        }
        else if (dynamicFormObject.displayFields && dynamicFormObject.displayFields.length > 0) {
            if (dynamicFormObject.type === 'array' || dynamicFormObject.type === 'group' || dynamicFormObject.type === 'groupselect') {
                label = this.getArrayHeader(dynamicForm, dynamicFormObject, data, xpath);
            }
            else if (dynamicFormObject.type === 'form') {
                if (dynamicFormObject.refFormType === 'external') {
                    label = this.getExternalFormHeader(dynamicForm, dynamicFormObject, data, xpath, externalForm);
                }
                else {
                    label = this.getInternalFormHeader(dynamicForm, dynamicFormObject, data, xpath);
                }
            }
        }
        let tmpStatus = '';
        if (status && statuses) {
            let index = statuses.status.findIndex(item => item.name === status);
            if (index >= 0) {
                tmpStatus = ' [' + statuses.status[index].label + ']';
            }
        }
        if (label > '') {
            return label + tmpStatus;
        }
        else {
            return this.getProperty(data, dynamicForm, dynamicFormObject, 'shortlabel') + tmpStatus;
        }
    }
    getGroupHeader(dynamicForm, dynamicFormObject, data, xpath) {
        let label = '';
        return label;
    }
    getExternalFormHeader(dynamicForm, dynamicFormObject, data, xpath, externalForm) {
        let label = '';
        for (let i = 0; i < externalForm.components.length; i++) {
            if (externalForm.components[i].type !== 'form') {
                if (dynamicFormObject.displayFields.includes(externalForm.components[i].id)) {
                    let value;
                    if (externalForm.components[i].refOptionsId) {
                        let options = this.optionService.getOptionItems(externalForm, externalForm.components[i].refOptionsId);
                        let selectedOptions = data[externalForm.components[i].code];
                        let values = [];
                        for (let k = 0; k < selectedOptions.length; k++) {
                            let idx = options.findIndex(o => o.value === selectedOptions[k]);
                            if (idx >= 0) {
                                values.push(options[idx].label);
                            }
                            else {
                                values.push(selectedOptions[k]);
                            }
                        }
                        if (values.length > 0) {
                            value = values.toString();
                        }
                        else {
                            value = data[externalForm.components[i].code] || '<none>';
                        }
                    }
                    else {
                        value = data[externalForm.components[i].code] || '<none>';
                    }
                    label = this.applyHeaderTemplate(dynamicFormObject.displayTemplate, label, externalForm.components[i].code, this.getProperty(data, externalForm, externalForm.components[i], 'shortlabel'), value);
                }
            }
            else {
                let components = this.dynamicFormService.getNestedFormChildren(dynamicForm, externalForm.components[i].refFormId);
                for (let j = 0; j < components.length; j++) {
                    if (dynamicFormObject.displayFields.includes(components[j].id)) {
                        let value;
                        if (components[j].refOptionsId) {
                            let options = this.optionService.getOptionItems(this.dynamicFormService.getForm(dynamicForm, externalForm.components[i].refFormId), components[j].refOptionsId);
                            let selectedOptions = data[externalForm.components[i].code][components[j].code];
                            let values = [];
                            for (let k = 0; k < selectedOptions.length; k++) {
                                let idx = options.findIndex(o => o.value === selectedOptions[k]);
                                if (idx >= 0) {
                                    values.push(options[idx].label);
                                }
                                else {
                                    values.push(selectedOptions[k]);
                                }
                            }
                            if (values.length > 0) {
                                value = values.toString();
                            }
                            else {
                                value = data[externalForm.components[i].code][components[j].code] || '<none>';
                            }
                        }
                        else {
                            value = data[externalForm.components[i].code][components[j].code] || '<none>';
                        }
                        label = this.applyHeaderTemplate(dynamicFormObject.displayTemplate, label, components[j].code, this.getProperty(data, this.dynamicFormService.getForm(dynamicForm, externalForm.components[i].refFormId), components[j], 'shortlabel'), value);
                    }
                }
            }
        }
        return label;
    }
    getInternalFormHeader(dynamicForm, dynamicFormObject, data, xpath) {
        let label = '';
        return label;
    }
    getArrayHeader(dynamicForm, dynamicFormObject, data, xpath) {
        let label = '';
        for (let i = 0; i < dynamicFormObject.components.length; i++) {
            if (dynamicFormObject.components[i].type !== 'form') {
                if (dynamicFormObject.displayFields.includes(dynamicFormObject.components[i].id)) {
                    let value;
                    if (dynamicFormObject.components[i].refOptionsId) {
                        let options = this.optionService.getOptionItems(dynamicForm, dynamicFormObject.refOptionsId);
                        let selectedOptions = data[dynamicFormObject.components[i].code];
                        let values = [];
                        for (let k = 0; k < selectedOptions.length; k++) {
                            let idx = options.findIndex(o => o.value === selectedOptions[k]);
                            if (idx >= 0) {
                                values.push(options[idx].label);
                            }
                            else {
                                values.push(selectedOptions[k]);
                            }
                        }
                        if (values.length > 0) {
                            value = values.toString();
                        }
                        else {
                            value = data[dynamicFormObject.components[i].code] || '<none>';
                        }
                    }
                    else {
                        value = data[dynamicFormObject.components[i].code] || '<none>';
                    }
                    label = this.applyHeaderTemplate(dynamicFormObject.displayTemplate, label, dynamicFormObject.components[i].code, this.getProperty(data, dynamicForm, dynamicFormObject.components[i], 'shortlabel'), value);
                }
            }
            else {
                let components = this.dynamicFormService.getNestedFormChildren(dynamicForm, dynamicFormObject.components[i].refFormId);
                for (let j = 0; j < components.length; j++) {
                    if (dynamicFormObject.displayFields.includes(components[j].id)) {
                        let value;
                        if (components[j].refOptionsId) {
                            let options = this.optionService.getOptionItems(this.dynamicFormService.getForm(dynamicForm, dynamicFormObject.components[i].refFormId), components[j].refOptionsId);
                            let selectedOptions = data[dynamicFormObject.components[i].code][components[j].code];
                            let values = [];
                            for (let k = 0; k < selectedOptions.length; k++) {
                                let idx = options.findIndex(o => o.value === selectedOptions[k]);
                                if (idx >= 0) {
                                    values.push(options[idx].label);
                                }
                                else {
                                    values.push(selectedOptions[k]);
                                }
                            }
                            if (values.length > 0) {
                                value = values.toString();
                            }
                            else {
                                value = data[dynamicFormObject.components[i].code][components[j].code] || '<none>';
                            }
                        }
                        else {
                            value = data[dynamicFormObject.components[i].code][components[j].code] || '<none>';
                        }
                        label = this.applyHeaderTemplate(dynamicFormObject.displayTemplate, label, components[j].code, this.getProperty(data, this.dynamicFormService.getForm(dynamicForm, dynamicFormObject.components[i].refFormId), components[j], 'shortlabel'), value);
                    }
                }
            }
        }
        return label;
    }
    applyHeaderTemplate(template, header, code, label, value) {
        if (template > '') {
            //A template is provided, so it's necessary to fill it with the component value
            let placeholder = '${' + code + '}';
            header = header.replace(placeholder, value);
        }
        else {
            header = header + (header > '' ? ' - ' : '') + label + ': ' + value;
        }
        return header;
    }
    getFormProperty(data, dynamicForm, id, name, lang, subform) {
        return this.getProperty(data, dynamicForm, { refPropertiesId: id }, name, lang, subform);
    }
    getProperty(data, dynamicForm, dynamicFormObject, name, lang, subform) {
        if (dynamicForm?.properties) {
            let refPropId = (subform ? subform + "." : "") + dynamicFormObject.refPropertiesId;
            if (dynamicFormObject.refPropertiesFormula) {
                refPropId = this.executeFormula(dynamicFormObject.refPropertiesFormula, data, dynamicForm.acceptedParams, dynamicForm.params);
            }
            let propId = refPropId || dynamicFormObject.refPropertiesId || dynamicFormObject.pathId;
            let items = dynamicForm.properties.filter(item => item.id === propId);
            if (items.length > 1) {
                let subitems = items.filter(item => item.lang === (lang || this.configService.env.currentLang));
                if (subitems.length === 0) {
                    subitems = items.filter(item => item.lang === this.configService.env.defaultLang);
                    if (subitems.length > 0) {
                        return subitems[0][name];
                    }
                    else {
                        return (this.isRequired(name) ? dynamicFormObject.code : '');
                    }
                }
                else {
                    return subitems[0][name] || (this.isRequired(name) ? dynamicFormObject.code : '');
                }
            }
            else if (items.length > 0) {
                return items[0][name] || (this.isRequired(name) ? dynamicFormObject.code : '');
            }
            else {
                return (this.isRequired(name) ? dynamicFormObject.code : '');
            }
        }
        else {
            return (this.isRequired(name) ? dynamicFormObject.code : '');
        }
    }
    getGenericProperty(collectionForm, id, type, lang, params) {
        let property = this.getProperty(null, collectionForm.form, {
            refPropertiesId: id,
            code: id
        }, type, lang);
        if (params) {
            for (let key in params) {
                property = property.replace("${" + key + "}", params[key]);
            }
        }
        return property;
    }
    setValidations(dynamicForm, components, rootFormGroup, formGroup, xpath) {
        for (let i = 0; i < components.length; i++) {
            let f = components[i];
            let dfo = new DynamicFormObject(f);
            if (this.dynamicFormService.controlTypes.includes(dfo.type) || dfo.type === 'checkboxlist' || dfo.type === 'groupselect') {
                this.createFormControlValidators(dynamicForm, f, rootFormGroup, formGroup.get(dfo.code), xpath);
            }
            /*       else if (dfo.type === 'groupselect')
                  {
                    for (let i = 0; i < dfo.refOptionsMappings.length; i++)
                    {
                      let comp: DynamicFormObject = JSON.parse(JSON.stringify(dfo.refOptionsMappings[i]));
                      comp.validation = dfo.validation;
            
                      this.createFormControlValidators(dynamicForm, comp, rootFormGroup, formGroup.get(dfo.refOptionsMappings[i].name), xpath);
                    }
                  } */
            if (dfo.components && dfo.components.length > 0) {
                if (dfo.type === 'array' || (dfo.type === 'group' && dfo.multipleValues === true) || (dfo.type === 'groupselect' && dfo.multipleValues === true)) {
                    if (formGroup.get(dfo.code).at(0)) {
                        this.setValidations(dynamicForm, dfo.components, rootFormGroup, formGroup.get(dfo.code).at(0), this.getXpath(dfo, xpath));
                    }
                }
                else {
                    this.setValidations(dynamicForm, dfo.components, rootFormGroup, formGroup.get(dfo.code), this.getXpath(dfo, xpath));
                }
            }
        }
    }
    createFormControlValidators(df, dfo, rootFormGroup, formControl, xpath) {
        if (formControl) {
            if (dfo.validation) {
                formControl.setValidators([customValidator(df, dfo, this, rootFormGroup, xpath)]);
                if (dfo.validation.required) {
                    formControl.addValidators(Validators.required);
                }
            }
        }
    }
    createRootForm(dynamicForm, operation, data) {
        let rootFormGroup = this.formObjectsToFormGroup(dynamicForm, operation, this.dynamicFormService.getRootForm(dynamicForm), data, '');
        this.setValidations(dynamicForm, this.dynamicFormService.getRootForm(dynamicForm), rootFormGroup, rootFormGroup, '');
        rootFormGroup.addControl('id', new FormControl(data ? data.id : null));
        return rootFormGroup;
    }
    formObjectsToFormGroup(dynamicForm, operation, components, data, xpath) {
        let formGroup;
        let group = {};
        if (components) {
            for (let i = 0; i < components.length; i++) {
                let f = components[i];
                let dfo = new DynamicFormObject(f);
                if (dfo.type === 'group' || dfo.type === 'groupselect') {
                    if (!dfo.multipleValues) {
                        group[dfo.code] = this.formObjectsToFormGroup(dynamicForm, operation, this.dynamicFormService.getComponentChildren(dfo), data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                    }
                    else {
                        group[dfo.code] = this.multipleFormGroupToFormArray(dynamicForm, operation, dfo, data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                    }
                }
                else if (dfo.type === 'keyselect') {
                    dfo.components = this.getKeyselectComponents(dfo.pathId);
                    if (!dfo.multipleValues) {
                        group[dfo.code] = this.formObjectsToFormGroup(dynamicForm, operation, this.dynamicFormService.getComponentChildren(dfo), data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                    }
                    else {
                        group[dfo.code] = this.multipleFormGroupToFormArray(dynamicForm, operation, dfo, data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                    }
                }
                else if (dfo.type === 'checkboxlist') {
                    group[dfo.code] = new UntypedFormArray([]);
                    if (data && data[dfo.code]) {
                        for (let i = 0; i < data[dfo.code].length; i++) {
                            group[dfo.code].push(new FormGroup({
                                label: new FormControl(data[dfo.code][i].label),
                                value: new FormControl(data[dfo.code][i].value)
                            }));
                        }
                    }
                    if (operation === 'edit' && dfo.editBlocked) {
                        group[dfo.code].disable();
                    }
                }
                else if (dfo.type === 'form') {
                    if (!dfo.refFormType || dfo.refFormType === 'internal') {
                        if (!dfo.multipleValues) {
                            if (data && data[dfo.code]) {
                                group[dfo.code] = this.formObjectsToFormGroup(this.dynamicFormService.getForm(dynamicForm, dfo.refFormId), operation, this.dynamicFormService.getNestedFormChildren(dynamicForm, dfo.refFormId), data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                            }
                            else {
                                if (data && data.length > 0) {
                                    group[dfo.code] = this.formObjectsToFormGroup(this.dynamicFormService.getForm(dynamicForm, dfo.refFormId), operation, this.dynamicFormService.getNestedFormChildren(dynamicForm, dfo.refFormId), data ? data[0][dfo.code] : null, this.getXpath(dfo, xpath));
                                }
                                else {
                                    group[dfo.code] = this.formObjectsToFormGroup(this.dynamicFormService.getForm(dynamicForm, dfo.refFormId), operation, this.dynamicFormService.getNestedFormChildren(dynamicForm, dfo.refFormId), data, this.getXpath(dfo, xpath));
                                }
                            }
                        }
                        else {
                            if (data && data[dfo.code]) {
                                group[dfo.code] = this.multipleFormToFormArray(this.dynamicFormService.getForm(dynamicForm, dfo.refFormId), operation, this.dynamicFormService.getNestedFormChildren(dynamicForm, dfo.refFormId), data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                            }
                            else {
                                if (data && data.length > 0) {
                                    group[dfo.code] = this.multipleFormToFormArray(this.dynamicFormService.getForm(dynamicForm, dfo.refFormId), operation, this.dynamicFormService.getNestedFormChildren(dynamicForm, dfo.refFormId), data ? data[0][dfo.code] : null, this.getXpath(dfo, xpath));
                                }
                                else {
                                    group[dfo.code] = this.multipleFormToFormArray(this.dynamicFormService.getForm(dynamicForm, dfo.refFormId), operation, this.dynamicFormService.getNestedFormChildren(dynamicForm, dfo.refFormId), data, this.getXpath(dfo, xpath));
                                }
                            }
                        }
                    }
                    else {
                        if (!dfo.multipleValues) {
                            group[dfo.code] = new FormGroup({});
                        }
                        else {
                            group[dfo.code] = new FormArray([]);
                        }
                    }
                    if (operation === 'edit' && dfo.editBlocked) {
                        group[dfo.code].disable();
                    }
                }
                else if (dfo.type === 'latlong') {
                    group[dfo.code] = this.formObjectsToFormGroup(dynamicForm, operation, this.dynamicFormService.getComponentChildren(dfo), data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                    if (operation === 'edit' && dfo.editBlocked) {
                        group[dfo.code].disable();
                    }
                }
                else if (dfo.type === 'array') {
                    group[dfo.code] = this.formObjectToFormArray(dynamicForm, operation, dfo, data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                    if (operation === 'edit' && dfo.editBlocked) {
                        group[dfo.code].disable();
                    }
                }
                else if (dfo.type === 'truefalse') {
                    group[dfo.code] = this.createFormControl(dynamicForm, f, data ? data[dfo.code] || false : false);
                    if (operation === 'edit' && dfo.editBlocked) {
                        group[dfo.code].disable();
                    }
                }
                else if (dfo.type === 'geogeometry') {
                    if (dfo.multipleValues) {
                        let c = [];
                        if (data && data[dfo.code]) {
                            for (let i = 0; i < data[dfo.code].length; i++) {
                                let children = [];
                                if (data && data[dfo.code] && data[dfo.code][i].geometries) {
                                    for (let j = 0; j < data[dfo.code][i].geometries.length; j++) {
                                        children.push(new FormControl(data[dfo.code][i].geometries[j]));
                                    }
                                }
                                c.push(new FormGroup({
                                    type: new FormControl("GeometryCollection"),
                                    geometries: new UntypedFormArray(children)
                                }));
                            }
                        }
                        group[dfo.code] = new FormArray(c);
                    }
                    else {
                        let children = [];
                        if (data && data[dfo.code] && data[dfo.code].geometries) {
                            for (let i = 0; i < data[dfo.code].geometries.length; i++) {
                                children.push(new FormControl(data[dfo.code].geometries[i]));
                            }
                        }
                        group[dfo.code] = new FormGroup({
                            type: new FormControl("GeometryCollection"),
                            geometries: new UntypedFormArray(children)
                        });
                    }
                }
                else if (this.dynamicFormService.controlTypes.includes(dfo.type)) {
                    //Split of the behavior depending on the multipleValues property
                    if (!dfo.multipleValues) {
                        group[dfo.code] = this.createFormControl(dynamicForm, f, data ? data[dfo.code] : null);
                    }
                    else {
                        if (dfo.type === 'select') {
                            group[dfo.code] = this.createFormControl(dynamicForm, f, data ? data[dfo.code] : null);
                        }
                        else {
                            group[dfo.code] = this.multipleFormObjectToFormArray(dynamicForm, operation, dfo, data ? data[dfo.code] : null, this.getXpath(dfo, xpath));
                        }
                    }
                    if (operation === 'edit' && dfo.editBlocked) {
                        group[dfo.code].disable();
                    }
                }
                else {
                    console.warn("dynamicFormObject type not found: " + dfo.type);
                    console.log(dfo);
                }
            }
            formGroup = new FormGroup(group);
        }
        return formGroup;
    }
    /**
     * Creates a FormArray object from the JSON descriptor.
      The application assumes that every formarray has a formgroup as child
  
     * @param {dynamicFormObject} DynamicFormObject the JSON object describing the formArray
     * @return {FormArray} returns the FormArray
     */
    formObjectToFormArray(dynamicForm, operation, dynamicFormObject, data, xpath) {
        let c = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                c.push(this.formObjectsToFormGroup(dynamicForm, operation, this.dynamicFormService.getComponentChildren(dynamicFormObject), data[i], xpath));
            }
        }
        let f = new UntypedFormArray(c);
        return f;
    }
    multipleFormObjectToFormArray(dynamicForm, operation, dynamicFormObject, data, xpath) {
        let c = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                c.push(this.createFormControl(dynamicForm, dynamicFormObject, data[i] ? data[i] : null));
            }
        }
        let f = new UntypedFormArray(c);
        return f;
    }
    multipleFormToFormArray(dynamicForm, operation, components, data, xpath) {
        let c = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                c.push(this.formObjectsToFormGroup(dynamicForm, operation, components, data[i] ? data[i] : null, xpath));
            }
        }
        let f = new UntypedFormArray(c);
        return f;
    }
    multipleFormGroupToFormArray(dynamicForm, operation, dynamicFormObject, data, xpath) {
        let c = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                c.push(this.formObjectsToFormGroup(dynamicForm, operation, dynamicFormObject.components, data[i] ? data[i] : null, xpath));
            }
        }
        let f = new UntypedFormArray(c);
        return f;
    }
    createFormControl(df, dfo, data) {
        let value = this.setDefaultValue(df, dfo, data);
        let formControl = null;
        if (dfo.required) {
            if (dfo.type === 'number') {
                formControl = new FormControl(value, Validators.required);
            }
            else {
                formControl = new UntypedFormControl(value, Validators.required);
            }
        }
        else {
            if (dfo.type === 'number') {
                formControl = new FormControl(value);
            }
            else {
                formControl = new UntypedFormControl(value);
            }
        }
        //formControl.setValue(value);
        return formControl;
    }
    /**
     * Sets the default value, if any, for the FormControl based on the value specified on the DynamicFormObject
     *
     * @param {DynamicForm} df the root DynamicForm
     * @param {DynamicFormObject} dfo the DynamicFormObject
     * @return {<any>} returns the value or empty string
     */
    setDefaultValue(df, dfo, data) {
        if (data) {
            return data;
        }
        let selectedOptions = this.optionService.getComponentSelectedOptions(df, dfo.refOptionsId);
        let value;
        if (dfo.type === "select" || dfo.type === "radiolist") {
            if (selectedOptions && selectedOptions.length > 0) {
                value = selectedOptions[0];
            }
            else {
                value = null;
            }
        }
        else if (dfo.type === 'checkboxlist' || dfo.type === 'groupselect') {
            value = selectedOptions || null;
        }
        else if (dfo.type === "checkbox") {
            value = (dfo.value === "true");
        }
        else if (dfo.type === "number") {
            if (dfo.value) {
                if (!isNaN(dfo.value)) {
                    value = Number(dfo.value);
                }
                else {
                    value = null;
                }
            }
            else {
                value = null;
            }
        }
        else {
            if (dfo.value) {
                switch (dfo.value) {
                    case '$_$currentUser$_$':
                        value = this.settings.username || '';
                        break;
                    case "$_$today$_$":
                        value = new Date();
                        break;
                    default:
                        value = dfo.value || null;
                }
            }
            else {
                return null;
            }
        }
        return value;
    }
    regenerateComponentsUUIDs(items) {
        let newItems = [];
        if (items) {
            for (let i = 0; i < items.length; i++) {
                let dfo = new DynamicFormObject(items[i]);
                this.dynamicFormService.setComponentChildren(dfo, this.regenerateComponentsUUIDs(this.dynamicFormService.getComponentChildren(dfo)));
                newItems.push(dfo);
            }
        }
        return newItems;
    }
    setFormComponentValue(operation, df, dfo, form, parentForm, xpath) {
        if (dfo.formulaValue && ((operation === 'new') || (operation === 'edit' && !dfo.editBlocked && !form.controls[dfo.code]))) {
            try {
                let value = this.executeFormula(dfo.formulaValue, parentForm.getRawValue(), df.acceptedParams, df.params, xpath);
                form.controls[dfo.code].setValue(value || "");
            }
            catch (error) {
                form.controls[dfo.code].setValue(dfo.value || "");
                console.log(dfo.code + ' - ' + dfo.formulaValue + ' - ' + error.code + ' - ' + error.message);
            }
        }
    }
    executeFormula(formula, data, acceptedParams, params, xpath) {
        let returnObject = false;
        let newFormula = this.constructGlobalFormula(acceptedParams, params, data);
        if (formula?.includes("value:=")) {
            formula = formula.replace("value:=", "");
            returnObject = true;
        }
        if (xpath > '') {
            formula = xpath + '.(' + formula + ')';
        }
        newFormula = '(' + newFormula + ' ' + formula + ')';
        let value = jsonata(newFormula).evaluate(data);
        return returnObject ? { value: value } : value;
    }
    constructGlobalFormula(acceptedParams, params, data) {
        let newFormula = '';
        //Injection of the global functions
        if (this.configService.env.jsonata > '') {
            newFormula = this.configService.env.jsonata;
        }
        //Injection of the form parameter values
        if (acceptedParams && params) {
            for (let i = 0; i < acceptedParams.length; i++) {
                let index = params.findIndex(item => item.name === acceptedParams[i].name);
                if (index >= 0) {
                    let p = params[index];
                    if (p.formula) {
                        try {
                            p.value = this.executeFormula(p.formula, data);
                        }
                        catch (error) {
                            console.log(p.formula + ' - ' + error.code + ' - ' + error.message);
                        }
                    }
                    if (acceptedParams[i].type === 'string') {
                        newFormula = (newFormula > '' ? newFormula + ' ' : '') + '$' + p.name + ' := "' + p.value + '";';
                    }
                    else {
                        newFormula = (newFormula > '' ? newFormula + ' ' : '') + '$' + p.name + ' := ' + p.value + ';';
                    }
                }
            }
        }
        return newFormula;
    }
    deleteComponent(dynamicForm, parent, current) {
        if (parent.id === dynamicForm.id) {
            let parentRoot = this.dynamicFormService.getRootForm(parent);
            //Deleting component from the root
            var index = parentRoot.findIndex(item => item.pathId === current.pathId);
            if (parentRoot[index].type === 'form') {
                let refFormId = parentRoot[index].refFormId;
                parentRoot.splice(index, 1);
                //After removing the deleted component, I search for other components referencing the same form
                let users = jsonPath.query(this.dynamicFormService.getRootForm(dynamicForm), '$..[?(@.refFormId==\'' + refFormId + '\')]');
                if (users.length === 0) {
                    this.dynamicFormService.removeNestedForm(dynamicForm, refFormId);
                }
            }
            else {
                parentRoot.splice(index, 1);
            }
        }
        else {
            //Deleting component from a group or an array
            var index = this.dynamicFormService.getComponentChildren(parent).findIndex(item => item.pathId === current.pathId);
            if (this.dynamicFormService.getComponentChildren(parent)[index].type === 'form') {
                let refFormId = this.dynamicFormService.getComponentChildren(parent)[index].refFormId;
                this.dynamicFormService.getComponentChildren(parent).splice(index, 1);
                //After removing the deleted component, I search for other components referencing the same form
                let users = jsonPath.query(this.dynamicFormService.getRootForm(dynamicForm), '$..[?(@.refFormId==\'' + refFormId + '\')]');
                if (users.length === 0) {
                    this.dynamicFormService.removeNestedForm(dynamicForm, refFormId);
                }
            }
            else {
                this.dynamicFormService.getComponentChildren(parent).splice(index, 1);
            }
        }
    }
    processVisibilityConditions(df, dfo, formData, xpath) {
        if (dfo.showIf > '') {
            return dfo.visible && this.processShowIfProperty(df, dfo, formData, xpath);
        }
        else if (dfo.hideIf > '') {
            return dfo.visible && !this.processHideIfProperty(df, dfo, formData, xpath);
        }
        else {
            return dfo.visible && true;
        }
    }
    processHideIfProperty(df, dfo, formData, xpath) {
        try {
            let value = this.executeFormula(dfo.hideIf, formData, df.acceptedParams, df.params, xpath);
            return value;
        }
        catch (error) {
            console.log(dfo.code + ' - ' + dfo.hideIf + ' - ' + dfo.formulaValue + ' - ' + error.code + ' - ' + error.message);
            return null;
        }
    }
    processShowIfProperty(df, dfo, formData, xpath) {
        try {
            let value = this.executeFormula(dfo.showIf, formData, df.acceptedParams, df.params, xpath);
            return value;
        }
        catch (error) {
            console.log(dfo.code + ' - ' + dfo.showIf + ' - ' + dfo.formulaValue + ' - ' + error.code + ' - ' + error.message);
            return null;
        }
    }
    static { this.ɵfac = function DynamicFormControlService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormControlService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(DynamicFormService), i0.ɵɵinject(OptionsService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DynamicFormControlService, factory: DynamicFormControlService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormControlService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: DynamicFormService }, { type: OptionsService }, { type: ConfigurationService }], null); })();

class DynamicForm {
    constructor(options = {}) {
        this.id = options.id;
        this.name = options.name;
        this.space = options.space;
        this.status = options.status;
        this.collection = options.collection;
        this.subform = options.subform;
        this.cssClass = options.cssClass || {};
        this.stylesheet = options.stylesheet;
        this.visibility = options.visibility || 'protected';
        this.comments = options.comments;
        this.validityStartDate = options.validityStartDate;
        this.validityEndDate = options.validityEndDate;
        this.closed = options.closed;
        this.options = options.options;
        this.components = options.components;
        this.forms = options.forms;
        this.properties = options.properties;
        this.acceptedParams = options.acceptedParams;
        this.params = options.params;
        this.viewConfig = options.viewConfig;
        this.dynamicFields = options.dynamicFields;
        this.joinOptions = options.joinOptions || [];
        this.externalFormsRefList = options.externalFormsRefList;
        this.optionFormsRefList = options.optionFormsRefList;
        if (this.validityStartDate === null) {
            this.validityStartDate = new Date();
        }
        if (this.validityEndDate === null) {
            this.validityEndDate = new Date();
            this.validityEndDate.setFullYear(this.validityEndDate.getFullYear() + 1);
        }
    }
}

class FormService {
    constructor(searchService, configService, dynamicFormService) {
        this.searchService = searchService;
        this.configService = configService;
        this.dynamicFormService = dynamicFormService;
    }
    createNewForm() {
        var newForm = new DynamicForm(this.getNewForm());
        return newForm;
    }
    getForms(space) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/forms/design/' + space + '?fields=id,name');
    }
    getNewForm() {
        return this.configService.env.defaultForm;
    }
    addSystemComponents(form) {
        if (!this.dynamicFormService.getRootForm(form)) {
            this.dynamicFormService.addRootForm(form);
        }
    }
    async computeExternalFormsReferences(parentDynamicForm, dynamicForm) {
        let components = jsonPath.query(this.dynamicFormService.getRootForm(dynamicForm), "$..[?(@.refFormId !== null && @.refFormId !== '' && @.refFormType==\'external\')]");
        for (let i = 0; i < components.length; i++) {
            let df = await this.getForm(dynamicForm.space, components[i].refFormId).toPromise();
            if (!df.space) {
                df.space = dynamicForm.space;
            }
            df.externalFormsRefList = [];
            parentDynamicForm = await this.computeExternalFormsReferences(parentDynamicForm, df);
        }
        parentDynamicForm.externalFormsRefList = parentDynamicForm.externalFormsRefList.concat(components.map(e => {
            return e.refFormId;
        }));
        return parentDynamicForm;
    }
    saveNewForm(form) {
        if (!form.cloned) {
            this.addSystemComponents(form);
        }
        return this.saveForm(form.space, form);
    }
    getForm(space, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/forms/design/' + space + '/' + id);
    }
    saveForm(space, form) {
        form = this.removeGlobalAcceptedParams(form);
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/forms/design/' + space, form);
    }
    updateForm(space, form) {
        form = this.removeGlobalAcceptedParams(form);
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/forms/design/' + space + '/' + form.id, form);
    }
    deleteForm(space, form) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/collection/forms/design/' + space + '/' + form.id);
    }
    removeGlobalAcceptedParams(form) {
        for (let i = form.acceptedParams?.length - 1; i >= 0; i--) {
            if (String(form.acceptedParams[i].name).startsWith('global_')) {
                form.acceptedParams.splice(i, 1);
            }
        }
        return form;
    }
    static { this.ɵfac = function FormService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(DynamicFormService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormService, factory: FormService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormService, [{
        type: Injectable
    }], () => [{ type: SearchService }, { type: ConfigurationService }, { type: DynamicFormService }], null); })();

class GroupsService {
    constructor(searchService, configService) {
        this.searchService = searchService;
        this.configService = configService;
    }
    getGroups(space) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/groups');
    }
    getGroup(space, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/groups/group/' + id);
    }
    createGroup(space, payload) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/space/' + space + '/groups/group', payload);
    }
    updateGroup(space, id, payload) {
        return this.searchService.put(this.configService.env.servicesUrl + '/workspace/space/' + space + '/groups/group/' + id, payload);
    }
    deleteGroup(space, id) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/workspace/space/' + space + '/groups/group/' + id);
    }
    static { this.ɵfac = function GroupsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GroupsService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GroupsService, factory: GroupsService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: SearchService }, { type: ConfigurationService }], null); })();

class ImageService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
    }
    getImage(imageUrl) {
        let parameters = new HttpParams();
        let headers = new HttpHeaders({
            'Content-Type': 'application/octec-stream',
            'Access-Control-Allow-Origin': '*'
        });
        return this.http.get(imageUrl, { headers: headers, responseType: 'blob', params: parameters });
    }
    static { this.ɵfac = function ImageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ImageService, factory: ImageService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: ConfigurationService }], null); })();

class MapService {
    constructor(http, configService, dynamicFormControlService) {
        this.http = http;
        this.configService = configService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.defaultPolygonStyles = [
            new Style({
                stroke: new Stroke({
                    color: 'rgba(56, 156, 205, 1)',
                    width: 2,
                }),
                fill: new Fill({
                    color: 'rgba(56, 156, 205, 0.2)',
                }),
            })
        ];
        this.defaultPointStyles = [
            new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 1)',
                    width: 2,
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 0.2)',
                }),
                image: new Icon({
                    anchor: [0.5, 0.96],
                    crossOrigin: 'anonymous',
                    src: 'assets/location_icon_24.png'
                })
            })
        ];
        this.projections = {
            mercator: {
                name: 'Mercator',
                srs: 'EPSG:3857',
                extent: [-20026376.39, -20048966.10, 20026376.39, 20048966.10],
                def: '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs'
            },
            south_polar: {
                name: 'South Polar',
                srs: 'EPSG:3031',
                transform: true,
                extent: [-3299207.53, -3333134.03, 3299207.53, 3333134.03],
                def: '+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs'
            },
            linear: {
                name: 'WGS84',
                srs: 'EPSG:4326',
                extent: [-180, -90, 180, 90],
                def: '+proj=longlat +datum=WGS84 +no_defs'
            },
            mollweide: {
                name: 'Mollweide',
                srs: 'ESRI:54009',
                extent: [-180.0, -90.0, 180.0, 90.0],
                def: '+proj=moll +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m no_defs'
            }
        };
        this.sharedLayers = {};
    }
    getMapConfiguration() {
        let config = {
            layers: [
                this.sharedLayers.un_continent2,
                this.sharedLayers.fao_major
            ]
        };
        return config;
    }
    getLayer(mapConfig, data, form, name, layer) {
        let newLayer = {
            url: mapConfig.layers[name].url,
            name: mapConfig.layers[name].name,
            dynamicName: mapConfig.layers[name].dynamicName,
            group: mapConfig.layers[name].group,
            title: this.dynamicFormControlService.getFormProperty(data, form, "layer." + mapConfig.layers[name].name, "label"),
            code: mapConfig.layers[name].code,
            style: mapConfig.layers[name].style,
            visible: mapConfig.layers[name].visible,
            opacity: mapConfig.layers[name].opacity,
            zindex: mapConfig.layers[name].zindex
        };
        if (layer) {
            for (let key in layer) {
                newLayer[key] = layer[key];
            }
        }
        return {
            type: mapConfig.layers[name].type || mapConfig.params.type || 'raster',
            name: newLayer.dynamicName || newLayer.name,
            group: newLayer.group,
            url: newLayer.url || mapConfig.params.url,
            title: newLayer.title,
            params: {
                SRS: mapConfig.layers[name].SRS || mapConfig.params.SRS,
                SERVICE: mapConfig.layers[name].SERVICE || mapConfig.params.SERVICE,
                VERSION: mapConfig.layers[name].VERSION || mapConfig.params.VERSION,
                REQUEST: mapConfig.layers[name].REQUEST || mapConfig.params.REQUEST,
                FORMAT: mapConfig.layers[name].FORMAT || mapConfig.params.FORMAT,
                TRANSPARENT: mapConfig.layers[name].TRANSPARENT || mapConfig.params.TRANSPARENT,
                LAYERS: newLayer.code,
                CQL_FILTER: newLayer.cql_filter,
                STYLES: newLayer.style,
                TILED: mapConfig.layers[name].TILED || mapConfig.params.TILED
            },
            visible: newLayer.visible !== undefined ? newLayer.visible : mapConfig.params.visible,
            opacity: newLayer.opacity || mapConfig.params.opacity,
            zindex: newLayer.zindex
        };
    }
    featureFromGeom(type, geometry) {
        let feature;
        if (type === "geoline") {
            feature = this.createLineFeature(geometry.coordinates);
        }
        else if (type === "geopolygon") {
            feature = this.createPolygonFeature(geometry.coordinates);
        }
        else if (type === "geopoint") {
            feature = this.createPointFeature(geometry.coordinates);
        }
        else if (type === "geogeometry") {
            if (geometry.type === ConfigurationService.olTypes.POLYGON || geometry.type === ConfigurationService.olTypes.CIRCLE || geometry.type === ConfigurationService.olTypes.BBOX) {
                feature = this.createPolygonFeature(geometry.coordinates);
            }
            else if (geometry.type === ConfigurationService.olTypes.POINT) {
                feature = this.createPointFeature(geometry.coordinates);
            }
            else if (geometry.type === ConfigurationService.olTypes.LINE) {
                feature = this.createLineFeature(geometry.coordinates);
            }
        }
        return feature;
    }
    bboxToPolygon(bbox) {
        let feature = new Feature(fromExtent(bbox));
        return feature;
    }
    polygonToBbox(coordinates) {
        let extent;
        let feature = this.createPolygonFeature(coordinates);
        var geoJsonGeom = new GeoJSON();
        var pp = JSON.parse(geoJsonGeom.writeGeometry(feature.getGeometry()));
        extent = feature.getGeometry().getExtent();
        return extent;
    }
    createPolygonFeature(polygon, styles) {
        let feature = new Feature({
            geometry: new Polygon(polygon)
        });
        feature.setStyle(styles);
        return feature;
    }
    createPointFeature(point, styles) {
        let feature = new Feature({
            geometry: new Point(point)
        });
        feature.setStyle(styles);
        return feature;
    }
    createLineFeature(point, styles) {
        let feature = new Feature({
            geometry: new LineString(point)
        });
        feature.setStyle(styles);
        return feature;
    }
    getBoundariesList(boundaries, condition = false) {
        let bnd = [];
        if (!boundaries) {
            boundaries = [];
        }
        for (let i = 0; i < boundaries.length; i++) {
            bnd.push(boundaries[i].iso3);
        }
        let list = '';
        for (let i = 0; i < bnd.length; i++) {
            if (condition) {
                list = list + ', \'' + bnd[i] + '\'';
            }
            else {
                list = list + 'OR ISO_3=\'' + bnd[i] + '\' ';
            }
        }
        if (list.startsWith(',')) {
            return list.substring(2);
        }
        else {
            return list.substring(3);
        }
    }
    getFeature(url, layerName, f, propertyName) {
        return this.http.get(url, {
            responseType: 'text',
            params: {
                request: "GetFeature",
                version: "1.0.0",
                typename: layerName,
                service: 'wfs',
                cql_filter: f,
                propertyName: propertyName
            }
        });
    }
    getExtentFromFeature(feature) {
        try {
            let strBbox = feature["WFS:FEATURECOLLECTION"]["GML:BOUNDEDBY"][0]["GML:BOX"][0]["GML:COORDINATES"][0]._;
            let bbox = strBbox.replace(' ', ',').split(',');
            for (let i = 0; i < bbox.length; i++) {
                bbox[i] = Number(bbox[i]);
            }
            return bbox;
        }
        catch (error) {
            return null;
        }
    }
    getProjection(proj, selected) {
        let projection = JSON.parse(JSON.stringify(proj));
        if (selected) {
            projection.default = selected;
        }
        return projection;
    }
    static { this.ɵfac = function MapService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MapService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(DynamicFormControlService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MapService, factory: MapService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: ConfigurationService }, { type: DynamicFormControlService }], null); })();

class UsersService {
    constructor(searchService, configService) {
        this.searchService = searchService;
        this.configService = configService;
    }
    getLoggedUser(space, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/user-permissions/id/' + id);
    }
    getUsers(space) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/users');
    }
    getSpaceUsers(space) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/user-settings');
    }
    getUserProfile(space, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/user-settings/id/' + id);
    }
    getUser(space, email) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/users/user/' + email);
    }
    createUser(space, payload) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/space/' + space + '/users/user', payload);
    }
    updateUser(space, id, payload) {
        return this.searchService.put(this.configService.env.servicesUrl + '/workspace/space/' + space + '/users/user/' + id, payload);
    }
    deleteUser(space, id) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/workspace/space/' + space + '/users/user/' + id);
    }
    createUserProfile(space, payload) {
        payload = this.cleanPayload(payload);
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/space/' + space + '/user-settings', payload);
    }
    updateUserProfile(space, id, payload) {
        payload = this.cleanPayload(payload);
        return this.searchService.put(this.configService.env.servicesUrl + '/workspace/space/' + space + '/user-settings/id/' + id, payload);
    }
    deleteUserProfile(space, id) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/workspace/space/' + space + '/user-settings/id/' + id);
    }
    cleanPayload(payload) {
        if (payload.effectiveRoles) {
            delete payload.effectiveRoles;
        }
        for (let i = 0; i < payload.roles.length; i++) {
            if (payload.roles[i].collections?.length === 0) {
                delete payload.roles[i].collections;
            }
            if (payload.roles[i].statuses?.edit?.length === 0) {
                delete payload.roles[i].statuses.edit;
            }
            if (payload.roles[i].statuses?.view?.length === 0) {
                delete payload.roles[i].statuses.view;
            }
            if (!payload.roles[i].statuses?.view && !payload.roles[i].statuses?.edit) {
                delete payload.roles[i].statuses;
            }
        }
        return payload;
    }
    static { this.ɵfac = function UsersService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UsersService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UsersService, factory: UsersService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UsersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: SearchService }, { type: ConfigurationService }], null); })();

class UtilsService {
    constructor(titleService, metaTagService, router, configService) {
        this.titleService = titleService;
        this.metaTagService = metaTagService;
        this.router = router;
        this.configService = configService;
        this.meta = {
            description: 'FAO Fisheries and Aquaculture Home Page',
            keywords: 'FAO,fishery',
            robots: 'index, follow',
            author: 'FAO',
            viewport: 'width=device-width, initial-scale=1',
            date: '2019-10-31',
            scheme: 'YYYY-MM-DD',
            charset: 'utf-8',
        };
    }
    makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }
    anchorClick(elementId) {
        document.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth' });
    }
    uniqueFilter(value, index, self) {
        return self.indexOf(value) === index;
    }
    getParentUrl() {
        return this.router.parseUrl(this.router.url).root.children.primary.segments.slice(0, this.router.parseUrl(this.router.url).root.children.primary.segments.length - 1).join('/');
    }
    getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }
    generateString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    processUrl(space, url) {
        if (!(space > "")) {
            space = this.configService.env.space;
        }
        if (url) {
            if (url.startsWith('fs://')) {
                url = this.configService.env.storageUrl + "/" + (space > "" ? space : "") + url.replace('fs:/', '');
            }
            else if (url.startsWith('/fishery/services/storage')) {
                url = this.configService.env.servicesUrl + url.substring(url.indexOf('/storage'));
            }
            else if (url.startsWith('/')) {
                let path = "services/storage/fs";
                if (url.includes(path)) {
                    url = url.substring(url.indexOf(path) + path.length);
                }
                url = this.configService.env.storageUrl + (space > "" ? "/" + space : "") + url;
            }
        }
        return url;
    }
    containsSpecialChars(str) {
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return specialChars.test(str);
    }
    decodeAdvanced(formItem, paramsMap) {
        let item = {};
        for (let key in formItem) {
            if (formItem[key] > '') {
                if (paramsMap[key]) {
                    item[paramsMap[key]] = formItem[key];
                }
                else {
                    item[key] = formItem[key];
                }
            }
        }
        return item;
    }
    stringifyAdvanced(item) {
        let advanced = '';
        for (let key in item) {
            if (item[key] > '') {
                advanced = advanced.concat(key + '=' + item[key] + ';');
            }
        }
        if (advanced > '') {
            advanced = advanced.substring(0, advanced.length - 1);
        }
        return advanced;
    }
    createAggregationQuery(aggType) {
        let aggQuery = '';
        for (let key in aggType) {
            if (aggQuery === '') {
                aggQuery = aggQuery + key + ':' + aggType[key].param;
                if (aggType[key].sort) {
                    aggQuery = aggQuery + ':' + aggType[key].sort;
                }
            }
            else {
                aggQuery = aggQuery + ',' + key + ':' + aggType[key].param;
                if (aggType[key].sort) {
                    aggQuery = aggQuery + ':' + aggType[key].sort;
                }
            }
        }
        return aggQuery;
    }
    camelCase(str) {
        if (str) {
            return str.substring(0, 1).toUpperCase() + str.substring(1);
        }
        else {
            return '';
        }
    }
    isObjectEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    isObjectHierarchyEmpty(obj) {
        if (obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key] != null) {
                    return false;
                }
            }
        }
        return true;
    }
    isFormEmpty(form) {
        if (form) {
            let formObj = form.getRawValue();
            if (this.isObjectHierarchyEmpty(formObj)) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
    hasValue(obj, prop) {
        let data = [];
        try {
            data = jsonPath.query(obj, '$.' + prop);
        }
        catch (e) {
        }
        if (data.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    hasValues(obj, prop) {
        if (obj && obj.length > 0) {
            for (let i = 0; i < obj.length; i++) {
                if (this.hasValue(obj[i], prop)) {
                    return true;
                }
            }
        }
        return false;
    }
    getValue(obj, prop) {
        let data = jsonPath.query(obj, '$.' + prop);
        if (data.length > 0) {
            return data[0];
        }
        else {
            return '';
        }
    }
    getValues(obj, prop) {
        let values = [];
        if (obj.length > 0) {
            for (let i = 0; i < obj.length; i++) {
                if (this.hasValue(obj[i], prop)) {
                    values.push(this.getValue(obj[i], prop));
                }
            }
        }
        return values;
    }
    titleCase(str) {
        // Step 1. Lowercase the string
        str = str.toLowerCase();
        // str = "I'm a little tea pot".toLowerCase();
        // str = "i'm a little tea pot";
        // Step 2. Split the string into an array of strings
        str = str.split(' ');
        // str = "i'm a little tea pot".split(' ');
        // str = ["i'm", "a", "little", "tea", "pot"];
        // Step 3. Create the FOR loop
        for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        // Step 4. Return the output
        return str.join(' '); // ["I'm", "A", "Little", "Tea", "Pot"].join(' ') => "I'm A Little Tea Pot"
    }
    getNestedPropertyId(data, property) {
        let langProperty = property.replaceAll("%lang%", this.configService.env.currentLang);
        let values = jsonPath.query(data, '$..values');
        if (values.length > 0) {
            if (langProperty.includes('.')) {
                let propValues = jsonPath.query(values[0][0], '$..' + langProperty);
                if (propValues.length > 0) {
                    return propValues[0];
                }
                else {
                    return '';
                }
            }
            else {
                return values[0][0][langProperty];
            }
        }
        else {
            return '';
        }
    }
    getPropertyId(data, property) {
        if (property) {
            let propValues = jsonPath.query(data, '$..' + property?.replaceAll("%lang%", this.configService.env.currentLang));
            if (propValues.length > 0) {
                return propValues[0];
            }
            else {
                return '';
            }
        }
        else {
            return property;
        }
    }
    setIndexingData(title, collection, description) {
        if (title) {
            this.titleService.setTitle(title);
            this.metaTagService.updateTag({ name: 'title', content: title });
            this.metaTagService.updateTag({ name: 'keywords', content: this.meta.keywords + ',' + title + ',' + (collection || "") });
        }
        if (description) {
            this.metaTagService.updateTag({ name: 'description', content: description });
        }
        else {
            this.metaTagService.updateTag({ name: 'description', content: title + ' - ' + window.location.href });
        }
        this.metaTagService.updateTag({ name: 'language', content: this.configService.env.currentLang || this.configService.env.defaultLang });
    }
    static { this.ɵfac = function UtilsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UtilsService)(i0.ɵɵinject(i1$1.Title), i0.ɵɵinject(i1$1.Meta), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UtilsService, factory: UtilsService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilsService, [{
        type: Injectable
    }], () => [{ type: i1$1.Title }, { type: i1$1.Meta }, { type: i2$1.Router }, { type: ConfigurationService }], null); })();

class AuthGuard {
    constructor(oauthService, configService) {
        this.oauthService = oauthService;
        this.configService = configService;
    }
    async canActivate(route, state) {
        await this.configService.getConfigurations();
        let currentRoute = this.configService.findRoute(state.url);
        if (!this.oauthService.hasValidAccessToken()) {
            if (this.configService.env.manager || (!this.configService.env.manager && currentRoute?.restricted)) {
                let redirectUri = this.configService.env.siteUrl + state.url;
                this.oauthService.configure(this.configService.env.authCodeFlowConfig);
                let newUrl;
                let urlDef = redirectUri.split("?");
                if (urlDef.length > 1) {
                    let newParams = [];
                    let params = urlDef[1].split("&");
                    for (let i = 0; i < params.length; i++) {
                        if (!params[i].startsWith("code=") && !params[i].startsWith("state=") && !params[i].startsWith("grant_type=")) {
                            newParams.push(params[i]);
                        }
                    }
                    newUrl = urlDef[0] + (newParams.length > 0 ? "?" + newParams.join("&") : "");
                }
                else {
                    newUrl = redirectUri;
                }
                if (newUrl > '') {
                    this.oauthService.redirectUri = newUrl;
                }
                this.oauthService.setupAutomaticSilentRefresh();
                return this.oauthService.loadDiscoveryDocumentAndLogin();
            }
            else {
                return true;
            }
        }
        this.configService.user = this.oauthService.getIdentityClaims();
        return this.oauthService.hasValidAccessToken();
    }
    static { this.ɵfac = function AuthGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AuthGuard)(i0.ɵɵinject(i2.OAuthService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable
    }], () => [{ type: i2.OAuthService }, { type: ConfigurationService }], null); })();

class LanguageService {
    constructor(location, router, route, configService) {
        this.location = location;
        this.router = router;
        this.route = route;
        this.configService = configService;
        this.languages = [
            { code: 'ar', label: 'العربية' },
            { code: 'zh', label: '中文' },
            { code: 'en', label: 'English' },
            { code: 'fr', label: 'Français' },
            { code: 'ru', label: 'Русский' },
            { code: 'es', label: 'Español' }
        ];
        this.rtlLangs = ['ar'];
        this.validLanguages = ['en', 'es', 'fr', 'ru', 'ar', 'zh'];
    }
    /**
     * Changes the language of the application, modifying the url and reloading the browser
     * @param lang language
     */
    changeLanguage(lang) {
        let urlTree = this.router.parseUrl(this.router.url);
        urlTree.queryParams = {};
        let url = urlTree.toString();
        //let url = this.router.url;
        let urlSegments = url.split('/');
        let languageSegmentIndex = urlSegments.indexOf(this.configService.env.currentLang);
        //no current lang in the url
        if (languageSegmentIndex === -1) {
            // If the url starts with a slash make sure to keep it.
            const injectionIndex = urlSegments[0] === '' ? 2 : 1;
            urlSegments = urlSegments.slice(0, injectionIndex).concat(this.configService.env.currentLang, urlSegments.slice(injectionIndex));
            //update the language segment index
            languageSegmentIndex = urlSegments.indexOf(this.configService.env.currentLang);
        }
        //replace language
        urlSegments[languageSegmentIndex] = lang;
        url = urlSegments.join('/');
        // Prevent multiple "/" character
        url = url.replace(/\/+/g, '/');
        const queryParamsObj = this.route.snapshot.queryParams;
        const extrasToApply = {};
        if (queryParamsObj) {
            extrasToApply.queryParams = queryParamsObj;
        }
        this.router.navigate([url], extrasToApply).then(() => window.location.reload());
    }
    /**
     * App initializer method loaded after the angular application is loaded
     * Gets the language from the url and sets the language into the ngx translator service
     */
    load() {
        this.configService.env.defaultLang = 'en';
        let url = unescape(this.location.path(true));
        let queryString;
        if (url.includes("?")) {
            queryString = url.substring(url.indexOf("?"));
            url = url.substring(0, url.indexOf("?"));
        }
        let urlSegments = url.split('/');
        let languageSegmentIndex = urlSegments.length > 0 ? this.validLanguages.indexOf(urlSegments[urlSegments.length - 1]) : -1;
        //first segment of the url does not include the language
        if (languageSegmentIndex === -1) {
            // If the url starts with a slash make sure to keep it.
            const injectionIndex = urlSegments[0] === '' ? 2 : 1;
            urlSegments = urlSegments.slice(0, injectionIndex).concat(this.configService.env.defaultLang, urlSegments.slice(injectionIndex));
            url = urlSegments.join('/');
            url = url.replace(/\/+/g, '/');
            this.router.navigate([url]);
            languageSegmentIndex = this.validLanguages.indexOf(this.configService.env.defaultLang);
        }
        //valid language defined as first segment
        const lang = this.validLanguages[languageSegmentIndex];
        this.configService.env.currentLang = lang;
        this.currentLang = lang;
        this.updateTextDirection(lang);
        // subscribe to router events
        this.router.events
            .pipe(filter(event => event instanceof NavigationStart), pairwise())
            .subscribe(this._routeChanged());
    }
    updateTextDirection(lang) {
        this.textDir = this.rtlLangs.indexOf(lang) > -1 ? 'rtl' : 'ltr';
    }
    /**
     * Event handler to react on route change
     */
    _routeChanged() {
        return ([previousEvent, currentEvent]) => {
            if (this.configService.env.currentLang === undefined) {
                this.configService.env.currentLang = this.configService.env.defaultLang;
            }
            //no valid language in the currentEvent url
            const routeChangedLang = this.getLocationLang(currentEvent.url);
            if (routeChangedLang === null) {
                this.router.navigateByUrl(this.configService.env.currentLang + currentEvent.url);
            }
            else if (this.configService.env.currentLang !== routeChangedLang) {
                //new language
                this.configService.env.currentLang = routeChangedLang;
            }
        };
    }
    /**
     * Get language from url
     */
    getLocationLang(url) {
        const queryParamSplit = (url || this.location.path()).split(/[\?;]/);
        let pathSlices = [];
        if (queryParamSplit.length > 0) {
            pathSlices = queryParamSplit[0].split('/');
        }
        if (pathSlices.length > 1 && this.validLanguages.indexOf(pathSlices[pathSlices.length - 1]) !== -1) {
            return pathSlices[pathSlices.length - 1];
        }
        if (pathSlices.length && this.validLanguages.indexOf(pathSlices[0]) !== -1) {
            return pathSlices[0];
        }
        return null;
    }
    static { this.ɵfac = function LanguageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LanguageService)(i0.ɵɵinject(i5.Location), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LanguageService, factory: LanguageService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LanguageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i5.Location }, { type: i2$1.Router }, { type: i2$1.ActivatedRoute }, { type: ConfigurationService }], null); })();

class PropertiesService {
    constructor(searchService, configService) {
        this.searchService = searchService;
        this.configService = configService;
        this.getCurrentSpaceProperties();
    }
    getFormProperties(space, form, lang) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/forms/design/' + space + '/' + form + '/properties/' + lang.toLowerCase());
    }
    updateFormProperties(space, form, lang, properties) {
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/forms/design/' + space + '/' + form + '/properties/' + lang.toLowerCase(), properties);
    }
    getCollectionProperties(space, collection, lang) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/fullproperties/' + lang.toLowerCase());
    }
    getCollectionFormProperties(space, collection, lang) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/properties/' + lang.toLowerCase());
    }
    updateCollectionProperties(space, collection, lang, properties) {
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/properties/' + lang.toLowerCase(), properties);
    }
    updateGlobalProperties(space, lang, properties) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/space/' + space + '/properties/' + lang.toLowerCase(), properties);
    }
    getGlobalProperties(space, lang) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/properties/' + lang.toLowerCase());
    }
    merge(globalProps, collectionProps) {
        let props = [];
        for (let i = 0; i < globalProps.length; i++) {
            let index2 = collectionProps.findIndex(item => item.id === globalProps[i].id && item.lang === globalProps[i].lang);
            if (index2 >= 0) {
                props.push(collectionProps[index2]);
            }
            else {
                props.push(globalProps[i]);
            }
        }
        for (let i = 0; i < collectionProps.length; i++) {
            let index = props.findIndex(item => item.id === collectionProps[i].id && item.lang === collectionProps[i].lang);
            if (index < 0) {
                props.push(collectionProps[i]);
            }
        }
        return props;
    }
    getCurrentSpaceProperties() {
        if (this.configService.env.space) {
            this.getGlobalProperties(this.configService.env.space, this.configService.env.currentLang).subscribe(globalProps => {
                this.spaceProperties = globalProps;
            });
        }
    }
    static { this.ɵfac = function PropertiesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PropertiesService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PropertiesService, factory: PropertiesService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PropertiesService, [{
        type: Injectable
    }], () => [{ type: SearchService }, { type: ConfigurationService }], null); })();

class TemplateService {
    constructor(searchService, configService) {
        this.searchService = searchService;
        this.configService = configService;
    }
    getDetailTemplates(space, collection) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/detail');
    }
    getListTemplates(space, collection) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/list');
    }
    getTemplates(space, collection, type) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type);
    }
    getTemplateById(space, collection, type, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type + '/' + id, "text");
    }
    getTemplateByIdCompressed(space, collection, type, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type + '/' + id + '/compressed', "text");
    }
    asyncGetTemplateByIdCompressed(space, collection, type, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type + '/' + id + '/compressed', "text").toPromise();
    }
    updateTemplates(space, collection, type, templates) {
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type, templates);
    }
    save(space, collection, type, template) {
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type, template);
    }
    update(space, collection, type, template) {
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type + '/' + template.id, template);
    }
    delete(space, collection, type, template) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/' + type + '/' + template.id);
    }
    updateDetailTemplates(space, collection, templates) {
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/detail', templates);
    }
    updateListTemplates(space, collection, templates) {
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/templates/detail', templates);
    }
    static { this.ɵfac = function TemplateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TemplateService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TemplateService, factory: TemplateService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplateService, [{
        type: Injectable
    }], () => [{ type: SearchService }, { type: ConfigurationService }], null); })();

class ListConfigService {
    constructor(searchService, configService) {
        this.searchService = searchService;
        this.configService = configService;
    }
    getListconfig(space, collection) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/listconfig');
    }
    getListconfigById(space, collection, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/listconfig/' + id);
    }
    saveListconfig(space, collection, listconfig) {
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/listconfig', listconfig);
    }
    updateListconfig(space, collection, id, listconfig) {
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/listconfig/' + id, listconfig);
    }
    deleteListconfigById(space, collection, id) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/collection/design/' + space + '/' + collection + '/listconfig/' + id);
    }
    static { this.ɵfac = function ListConfigService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ListConfigService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ListConfigService, factory: ListConfigService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListConfigService, [{
        type: Injectable
    }], () => [{ type: SearchService }, { type: ConfigurationService }], null); })();

class ErrorService {
    checkOnline() {
        if (!navigator.onLine) {
            return 'No Internet Connection';
        }
    }
    getClientMessage(error) {
        return error?.message ? error?.message : error?.toString();
    }
    getClientStack(error) {
        return error.stack;
    }
    getServerMessage(error) {
        var msg = error?.error?.Message;
        if (!!msg)
            return msg + " : " + error?.error?.ExceptionMessage;
        return "Application can not execute because API hasn\'t been started";
    }
    getServerStack(error) {
        return error.error.StackTrace;
    }
    static { this.ɵfac = function ErrorService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ErrorService, factory: ErrorService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const ERROR_HANDLERS = new InjectionToken('ERROR_HANDLERS');
class ErrorHandlerService {
    constructor(injector, messageService) {
        this.injector = injector;
        this.messageService = messageService;
        this.notify = false;
        this.messages = [];
    }
    handleError(error) {
        const errorService = this.injector.get(ErrorService);
        let message;
        let stackTrace = errorService.getClientStack(error);
        if (error instanceof HttpErrorResponse) // Server Error
            message = errorService.getServerMessage(error);
        else // Client Error
            message = errorService.getClientMessage(error);
        if (this.notify) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message.substring(0, 250) + "..." });
        }
        this.messages.push(error.message);
        throw error;
    }
    static { this.ɵfac = function ErrorHandlerService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorHandlerService)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i2$2.MessageService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ErrorHandlerService, factory: ErrorHandlerService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorHandlerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i0.Injector }, { type: i2$2.MessageService }], null); })();

class SecurityService {
    constructor(searchService, router, configService) {
        this.searchService = searchService;
        this.router = router;
        this.configService = configService;
    }
    getTokens(clientId) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/operations/authorization/' + clientId);
    }
    newToken(form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/operations/generateClientToken', form);
    }
    refreshToken(clientId, form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/operations/updateAuthorizationRequest/' + clientId, form);
    }
    markForDeletion(clientId, form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/operations/deleteAuthorizationRequest/' + clientId, form);
    }
    getClients() {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/operations/clients');
    }
    getClient(code) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/operations/client/' + code);
    }
    newClient(form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/operations/client', form);
    }
    updateClient(code, form) {
        return this.searchService.put(this.configService.env.servicesUrl + '/workspace/operations/client/' + code, form);
    }
    updateClientSecret(form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/operations/updateClientSecret', form, "text");
    }
    deleteWorkspace(code) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/workspace/' + code);
    }
    getWorkflows(space) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow');
    }
    getWorkflow(space, id) {
        return this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow/' + id);
    }
    newWorkflow(space, form) {
        return this.searchService.post(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow', form);
    }
    updateWorkflow(space, code, form) {
        return this.searchService.put(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow/' + code, form);
    }
    deleteWorkflow(space, code) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/workspace/space/' + space + '/workflow/' + code);
    }
    setCurrentSpace(space) {
        space = space || this.configService.env.space;
        if (!this.configService.env.spaces) {
            this.getClients().subscribe(res => {
                this.configService.env.spaces = res.workspaces.map(e => {
                    let item = {};
                    for (let key in e) {
                        item[key] = e[key];
                    }
                    item.title = e.name || e.code;
                    item.link = '/admin/spaces/' + e.code + '/' + this.configService.env.currentLang;
                    item.image = e.image || './assets/images/noimagefound.jpg';
                    if (e.roleType === 'ADMIN') {
                        item.description = '<div class="align-right"><space-manager-button space="' + e.code + '"></space-manager-button></div>';
                    }
                    item.target = "_self";
                    return item;
                });
                if (!space) {
                    if (this.router.url.includes("reporting")) {
                        this.router.navigate(["/home" + "/" + this.configService.env.currentLang]);
                    }
                }
                else {
                    let index = this.configService.env.spaces.findIndex(item => item.code === space);
                    if (index >= 0) {
                        this.configService.env.space = space;
                        this.configService.env.roleType = this.configService.env.spaces[index].roleType;
                    }
                }
            }, err => {
                this.searchService.manageError(err, 'Error extracting workspaces');
            });
        }
        else {
            if (!space) {
                if (this.router.url.includes("reporting")) {
                    this.router.navigate(["/home" + "/" + this.configService.env.currentLang]);
                }
            }
            else {
                let index = this.configService.env.spaces.findIndex(item => item.code === space);
                if (index >= 0) {
                    this.configService.env.space = space;
                    this.configService.env.roleType = this.configService.env.spaces[index].roleType;
                }
            }
        }
    }
    getCurrentSpace() {
        let index = this.configService.env.spaces.findIndex(item => item.code === this.configService.env.space);
        if (index >= 0) {
            return this.configService.env.spaces[index];
        }
        else {
            return null;
        }
    }
    highlightCurrentSpace() {
        for (let i = 0; i < this.configService.env.spaces?.length; i++) {
            if (this.configService.env.spaces[i].code === this.configService.env.space) {
                this.configService.env.spaces[i].cssclass = "highlight";
            }
            else {
                this.configService.env.spaces[i].cssclass = null;
            }
        }
    }
    static { this.ɵfac = function SecurityService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityService)(i0.ɵɵinject(SearchService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SecurityService, factory: SecurityService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SecurityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: SearchService }, { type: i2$1.Router }, { type: ConfigurationService }], null); })();

class RoutesResolver {
    constructor(route, router, configService) {
        this.route = route;
        this.router = router;
        this.configService = configService;
    }
    resolve() {
        return this.configService.user;
    }
    static { this.ɵfac = function RoutesResolver_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RoutesResolver)(i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RoutesResolver, factory: RoutesResolver.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoutesResolver, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i2$1.ActivatedRoute }, { type: i2$1.Router }, { type: ConfigurationService }], null); })();

class LightformsServicesModule {
    static forRoot(env) {
        return {
            ngModule: LightformsServicesModule,
            providers: [ConfigurationService, { provide: 'env', useValue: env }]
        };
    }
    static { this.ɵfac = function LightformsServicesModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LightformsServicesModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LightformsServicesModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            BsEventsService,
            ChartService,
            CollectionService,
            ConfigurationService,
            DynamicFormControlService,
            DynamicFormService,
            FormService,
            GroupsService,
            ImageService,
            LanguageService,
            LoggingService,
            MapService,
            OptionsService,
            QueryBuilder,
            SearchService,
            UsersService,
            UtilsService,
            WorkspaceService,
            SecurityService,
            AuthGuard,
            PropertiesService,
            TemplateService,
            ListConfigService,
            ErrorHandlerService,
            CacheService,
            RoutesResolver
        ], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule, CommonModule,
            FormsModule,
            ReactiveFormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightformsServicesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                providers: [
                    BsEventsService,
                    ChartService,
                    CollectionService,
                    ConfigurationService,
                    DynamicFormControlService,
                    DynamicFormService,
                    FormService,
                    GroupsService,
                    ImageService,
                    LanguageService,
                    LoggingService,
                    MapService,
                    OptionsService,
                    QueryBuilder,
                    SearchService,
                    UsersService,
                    UtilsService,
                    WorkspaceService,
                    SecurityService,
                    AuthGuard,
                    PropertiesService,
                    TemplateService,
                    ListConfigService,
                    ErrorHandlerService,
                    CacheService,
                    RoutesResolver
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LightformsServicesModule, { imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule], exports: [CommonModule,
        FormsModule,
        ReactiveFormsModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Aggregation, AggregationInput, AggregationItem, AuthGuard, BsEventsService, CacheService, ChartService, CollectionService, ConfigurationService, DynamicForm, DynamicFormControlService, DynamicFormObject, DynamicFormService, ERROR_HANDLERS, ErrorHandlerService, Filter, FormService, GeneralSearchParameter, GroupsService, ImageService, LanguageService, LightformsServicesModule, ListConfigService, LoggingService, MapService, NUMBER_SEARCH, NumberSearchParameter, OPTION_SEARCH, OptionSearch, OptionsService, PILL_SEARCH, PillSearch, PillSearchParameter, PropertiesService, QueryBuilder, RANGE_SEARCH, RangeSearch, ResultList, ResultSearchEvent, Results, RoutesResolver, SIMPLE_SEARCH, STANDARD_SEARCH, SearchOption, SearchOptions, SearchRequest, SearchResponse, SearchService, SecurityService, SimpleSearch, SimpleSearchParameter, StandardSearch, StandardSearchParameter, TemplateService, UNIT_RANGE_SEARCH, UiSearch, UnitRangeSearch, UsersService, UtilsService, ViewTypeEnum, WorkspaceService };
